import { OPEN_STATUS } from "@/enums/open-status-type";
import {
  FACILITY_STATUS,
  BING_FACILITY_STATUS
} from "@/enums/facility-status-type";
import { WEEK_DAYS } from "@/enums/week-days";
import {
  POST_TYPE,
  POSTS_FORM_TYPE,
  POSTS_CALL_TO_ACTION_TYPE,
  POST_BY_FACILITY_STATUS
} from "@/enums/posts.enum";
import { FACILITY_CREATE_ACTION } from "@/enums/gmb-search-type";
import { FACILITIES_SORTING_OPTION } from "@/enums/facilities-sorting-option";
import {
  PERIODIC_REPORT_TYPE,
  TOP_CHART_SERIE
} from "@/enums/charts-type.enum";
import { AccountType } from "@/enums/account-type";

import {
  EXTERNAL_CHANGES_SOURCE,
  EXTERNAL_CHANGES_TYPE,
  EXTERNAL_CHANGES_STATUS,
  EXTERNAL_CHANGES_FIELD
} from "@/enums/external-changes";
import { KEYWORDS_SCOPE } from "@/enums/keywords";
import { DIALOG_MANAGE_MODE } from "@/enums/reply-templates";
import { REVIEWS_TAGS_SEARCH_TYPE } from "@/enums/reviews.enum";
import { Module } from "@/enums/modules";
import { GMB_MEDIA_STATUS } from "@/enums/gmb-media-status";
import { GMB_MEDIA_TYPE } from "@/enums/gmb-media-type";

//messages.js
export default {
  common: {
    showMore: "Show more",
    showLess: "Show less",
    setPasswordAndFinishRegistration: "Set password and finish registration",
    page: "Page {0}",
    areas: "Areas",
    areaFacility: "Area location",
    areaFacilityTooltip:
      "You cannot select this location because it is a Service Area Business (SAB). Search results are not monitored for such locations.",
    expand: "Expand",
    copyAddress: "Copy address",
    readMore: "Read more",
    collapse: "Collapse",
    locations: "Locations",
    members: "Users",
    keywords: "Keywords",
    tags: "Review categories",
    competitors: "Competitor's location",
    yourFacility: "Your location",
    competitorsFacility: "Competitor's location",
    deleteSelected: "Delete selected",
    learnMore: "Learn more",
    name: "Name",
    stats: "Statistics",
    videoTutorialsTooltip: "Watch the video presenting this functionality.",
    faq: "Help",
    selectImportColumns: "Select the columns you want to import",
    upload: "Upload",
    addFile: "Add file",
    desktop: "desktop",
    exportToCSV: "Export to CSV",
    exportCSV: "Export CSV",
    exportToFile: "Export to file",
    mobile: "mobile",
    select: "Select",
    edited: "Edited",
    downloadStarted: "Download started",
    groups: "Groups",
    range: "Range",
    selectAddress: "Select address",
    dontShowItAgain: "Don't show it again",
    changeName: "Change name",
    show: "Show {0}",
    bestPractices: "Best Practices",
    dataProcessing: "Data processing in progress",
    points: "pts",
    above: "Above",

    allReviews: "All reviews",
    reviewsWithoutCategory: "Reviews without categories",
    accept: "Accept",
    accessibility: "Accessibility",
    accountData: "Account data",
    accountSettings: "Account settings",
    accountAdded: "Account added",
    accountDeleted: "Account deleted",
    accountType: "Account type",
    actions: "Actions",
    addDomain: "Add domain",
    add: "Add",
    addAccount: "Add account",
    addBusinessAddress: "Add location",
    addFacility: "Add Location",
    addFbId: "Add page ID",
    addManually: "Add manually",
    addMonitoredKeywords: "Add keywords for monitoring",
    addNew: "Add new",
    addNewTerm: "Add keyword",
    addOwnBusinessAddress: "Add own business location",
    addProfile: "Add profile",
    addProfileName: "Add profile name",
    additionalCategories: "Additional business categories",
    address: "Address",
    addUrlAddress: "Add URL",
    urlAddress: "URL address",
    after: "After",
    analytics: "Analytics",
    comparator: "Compare Google Maps listings",
    appliance: "Device",
    apply: "Apply",
    all: "All",
    allFacilities: "All business locations",
    more: "More",
    less: "Less",
    added: "Added",
    assignAccount: "Assign account",
    avg_rate_on_main_page: "Average rating in most relevant reviews",
    accurate_number_of_photos: "Photos",
    ascending: "Ascending",
    automatically: "Automatically",
    back: "Back",
    backToList: "Back to list",
    backToSignIn: "Back to sign in",
    before: "Before",
    businessAddress: "Company address",
    businessAddresses: "Locations",
    businessAddressesGroups: "Locations groups",
    businessAddressesList: "Locations list",
    businessAddressOrWww: "Location or website",
    billingData: "Billing data",
    by: "by",
    cancel: "Cancel",
    categories: "Categories",
    category: "Category",
    change: "Change",
    changeAccountType: "Change account type",
    changeSinceLastWeek: "Changes since last week",
    choose: "Choose",
    chooseDate: "Choose time slot",
    chooseGmbAccount: "Choose Google account",
    choosePeriod: "Choose range",
    chooseProfile: "Choose profile",
    chosenBusinessAddress: "Chosen location",
    city: "City",
    clear: "Clear",
    clients_activity_score: "Customer activity sheet",
    close: "Close",
    closed: "Closed",
    collectData: "Collecting data",
    companyName: "Business name in Center AI panel",
    legalCompanyName: "Company Name",
    taxNumber: "VAT ID",
    companyProfile: "Settings",
    compareWith: "Compare with",
    competition: "Competitors",
    competitionVisibility: "Comparison with the competition",
    competitiveBusinessAddresses: "Competitors locations",
    competitiveWebsites: "Competitors websites",
    confirm: "Confirm",
    confirmDelete: "Yes, delete",
    confirmPassword: "Confirm password",
    consentsAndRegulations: "Consents and Terms of Use",
    contact: "Contact details",
    contactPhone: "Mobile phone",
    contactWithUs: "Contact us",
    content: "Content",
    continue: "Continue",
    country: "Country",
    cover_photo: "Cover photo",
    createAccount: "Create an account",
    createBusinessAddress: "Create location",
    currentData: "Current data",
    dashboard: "Dashboard",
    day: "Day",
    dateFrom: "Date from",
    dateTo: "Date to",
    dateRange: "Date range",
    delete: "Delete",
    deletePicked: "Remove selected",
    descending: "Descending",
    description: "Description",
    details: "Details",
    seeDetails: "See details",
    direction: "Direction",
    doYouWantToSaveChanges: "Would you like to save changes?",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    edit: "Edit",
    editFromFile: "Edit from file",
    editData: "Edit data",
    email: "E-mail",
    emailAddress: "E-mail address",
    exportTo: "Export to:",
    exportData: "Export data",
    exportTo2: "Export to",
    exportGroupedByDates: "grouped by dates",
    exportGroupedByLocations: "grouped by locations",
    facility: "Location",
    facilityData: "Location data",
    facilityName: "Location name",
    fillYourCompanyData: "Complete Your Company Details",
    filter: "Filter",
    filters: "Filters",
    find: "Search for",
    findCity: "Find city",
    findPhrase: "Find phrase",
    findFacility: "Find location",
    followers: "Followed by",
    following: "Following",
    forgotPassword: "I forgot my password",
    from: "From",
    further: "Next",
    importedBusinessAddresses: "Imported locations",
    importFacilities: "Import locations",
    facilitiesCountIsOwnerTooltip:
      "Locations imported from Google Business Profile Manager. You can edit these locations.",
    facilitiesCountIsNotOwnerTooltip:
      "Locations added from outside Google Business Profile Manager. You cannot edit these locations.",
    facilityOpenStatus: "Opening status",
    importStatus: "Import status",
    openStatusLabel: {
      all: "All",
      open: "Open",
      closedPermanently: "Permanently closed",
      closedTemporarily: "Temporarily closed"
    },
    importStatusLabel: {
      any: "Any",
      imported: "Imported",
      notImported: "Not imported"
    },
    facilitiesStatus: "Locations status",
    facilitiesStatusInGoogleMaps: "Locations status in Google Maps",
    facilitiesStatusInBingMaps: "Locations status in Bing Maps",
    facilityIsOwnerTooltip:
      "Location imported from Google Business Profile Manager. You can edit this location.",
    facilityIsNotOwnerTooltip:
      "Location added from outside Google Business Profile Manager. You cannot edit this location.",
    freeTrialInfo:
      "Try Center AI free for {0} days – no credit card required. You won’t be charged unless you decide to pick a plan after your trial.",
    freeTrialTitle: "Let’s set things up!",
    general: "Main",
    generalData: "General data",
    gmb_analytics: "Analytics",
    googleMaps: "Google Maps",
    facebook: "Facebook",
    googleMyBusiness: "Google Business Profile Manager",
    govTaxNumber: "VAT ID",
    history: "History",
    importPicked: "Import selected",
    institution: "Location",
    lack: "None",
    lastAudit: "Last audit",
    likes: "Likes",
    list: "List",
    loadingTime: "Loading time",
    location: "Locality",
    login: "Sign in",
    logOut: "Sign out",
    manage: "Manage",
    maps: "Maps",
    marketingConsents: "Marketing consents",
    mobileAdaptation: "Mobile adaptation",
    month: "Month",
    moreInformations: "More",
    moreThan: "Above",
    newLocality: "New locality",
    newLocation: "New locality",
    newPassword: "New password",
    newTerm: "New keyword",
    newWebsite: "New website",
    next: "Next",
    noData: "No data",
    noDataDescription:
      "We are currently harvesting data. The information will be available here in a few hours.",
    noChanges: "No changes",
    none: "None",
    noRatings: "No ratings",
    number_of_photos: "Number of photos",
    number_of_posts: "Number of posts",
    ofPages: "out of",
    ok: "OK",
    oldPassword: "Previous password",
    open: "Open",
    open_hours: "Opening hours",
    openCloseFacilities: "Opening and closing locations",
    openCloseFacility: "Opening and closing location",
    openStreetMap: "Open Street Map",
    optional: "Optional",
    or: "or",
    other: "Other",
    overview: "Overview",
    password: "Password",
    performance: "Performance",
    perPage: "Items per page",
    phone_number: "Phone number",
    photos: "Photos",
    pickFacilities: "Choose locations",
    pickWebsite: "Choose website",
    pointer: "Item",
    pointers: "Pointers",
    poland: "Poland",
    position: "position",
    positionsCount: "Positions: {0}",
    positionAbove: "Outside of top {0}",
    postalCode: "Postal code",
    postcode: "Postal code",
    posts: "Posts",
    postsAdd: "Add post",
    postsEdit: "Edit post",
    postsList: "Posts",
    previewPhoto: "Photo preview",
    previous: "Previous",
    primaryCategory: "Primary business category",
    profile_photo: "Profile photo",
    profileDeleted: "Profile deleted",
    provideCode: "Enter code",
    quarter: "Quarter",
    rate: "Rating",
    rateCenter: "Center AI Rating",
    refresh: "Refresh",
    reject: "Reject",
    rememberMe: "Remember me",
    removeAccount: "Remove from Center AI",
    removeFacility: "Remove location",
    removeFacilities: "Remove locations",
    removeFilters: "Remove filters",
    removeProfile: "Remove from Center AI",
    repeatNewPassword: "Repeat new password",
    report: "Report",
    reportProblem: "Report problem",
    resend: "Resend",
    resetPassword: "Reset password",
    reviewers: "Reviews total",
    reviews_rating: "Average rating",
    reviews: "Google Maps rating",
    save: "Save",
    saveData: "Save data",
    savedDoneChanges: "Save changes to",
    facilities: "locations",
    search: "Search",
    searchCompany: "Search company",
    searchEngines: "Search engines",
    searchTerm: "Search keyword",
    searchTerms: "Monitored keywords",
    security: "Security",
    selectAll: "Select all",
    selectAllFromPage: "Select all on page",
    selectedCount: "Selected: {0}",
    sendEmail: "Send e-mail",
    seo: "Seo",
    settings: "Settings",
    showHistory: "Show history",
    showFacility: "Show details",
    signUp: "Sign up",
    signUpTrial: "Try it for free",
    signUpTitle:
      "Take care of your local visibility and business reputation. Gain loyal customers and grow your business.",
    signUpTrialTitle:
      "Sign up today and enjoy {0} days of the Standard plan – <b>no credit card required</b>. See how Center AI can help you bring in more local customers!",
    skip: "Skip",
    social: "Community",
    socialMedia: "Social media",
    sort: "Sort",
    sortBy: "Sort by",
    speed: "Speed",
    status: "Status",
    date: "Date",
    hour: "Hour",
    statusOnGoogleMaps: "Google Maps Status",
    statusOnGMB: "Google Business Profile Manager Status",
    storeCode: "Store code",
    street: "Street",
    subscription: "Subscription",
    suggested: "Suggested",
    summary: "Summary",
    tasksToDo: "To do list",
    termsOfService: "Privacy Policy",
    trade: "Business category",
    tryAgain: "Try again",
    to: "to",
    urlAttribute: "URL attribute",
    user_activity_score: "Your activity",
    userAccount: "User account",
    userName: "User name",
    userProfile: "User profile",
    voivodeship: "Region",
    website: "Website",
    websites: "Websites",
    week: "Week",
    www_analytics: "Website analytics",
    year: "Year",
    yourBusinessAddress: "Location address",
    yourBusinessAddresses: "You locations",
    yourCompany: "Your company",
    yourPosition: "Your position",
    yourPositionOnGoogleMaps: "Your position in Google Maps search results",
    yourSite: "Your site",
    yourVisibility: "Your visibility",
    yourWebsite: "Your website",
    yourWebsites: "Your websites",
    csv: "CSV",
    xls: "XLS",
    xlsx: "XLSX",
    yes: "Yes",
    no: "No",
    see: "See more",
    copiedToClipboard: "Copied to clipboard",
    filterByDateOf: "Filter by date of",
    reviewLastEdit: "Last edit",
    reviewCreation: "Creation",
    reviewLastEditOrCreation: "Last edit or creation",
    validation: {
      urlWithProtocol: "URL must start with http:// or https://",
      requiredField: "This field is required",
      maxLength: "Maximum length is {0} characters",
      minLength: "Minimum length is {0} characters",
      minWords: "The minimum number of words is {0}"
    }
  },

  pluralForms: {
    facility: ["location", "locations", "locations"],
    facilityGenitive: ["location", "locations", "locations"],
    facilityLocative: ["location", "locations", "locations"],
    city: ["city", "cities", "cities"],
    group: ["group", "groups", "groups"],
    groupGenitive: ["group", "groups", "groups"],
    review: ["review", "reviews", "reviews"],
    position: ["position", "positions", "positions"],
    click: ["click", "clicks", "clicks"],
    view: ["view", "views", "views"],
    changeAccusative: ["change", "changes", "changes"]
  },

  serviceUnavailable: {
    title: "System maintenance",
    description:
      "Sorry, Center AI web panel and API are currently unavailable due to planned maintenance work. System availability will be restored soon.",
    footer: "Thank you for your understanding,",
    signature: "<span style='color: #4a24ac'>Center AI</span> Team",
    backToMainPage: "Back to main page"
  },

  service: {
    accountSuspended:
      'We regret to inform you that your <a href="https://center.ai/" target="_blank">Center AI</a> account has been temporarily suspended due to an outstanding payment issue. To reinstate full account functionality and continue utilizing our solution, we kindly ask that you resolve the overdue balance. If you have any questions or concerns, please reach out to our Customer Support Team at <a href="mailto:support@center.ai">support@center.ai</a>.',
    subscriptionPlanExpired:
      "Your subscription plan has expired. To renew your subscription please go to settings.",
    wrongSubscriptionPlan:
      "You subscription plan does not allow to perform this action.",
    subscriptionLimit:
      "Number of allowed locations exceeded. Your subscription plan allows for X locations only. Contact us if you would like to increase your location quota."
  },

  dashboard: {
    clientScoreHistory: "Your Google Maps Review timeline",
    lastMonth: "starting last month",
    googleMaps: "Google Maps visibility",
    googleMyBusiness: "Google Maps locations quality",
    fromLastWeek: "starting last week",
    fromLastMonth: "starting last month",
    fromLast30Days: "within last 30 days",
    selectAll: "Select all",
    noDataFromLastMonth: "No data for last month",
    competitionBusiness: "Competitors",
    visibility: "Visibility",
    quality: "Quality",

    checkbox: {
      overallRate: "Overall rating",
      googleOrganic: "Google search results visibility",
      googleMaps: "Google Maps visibility",
      googleMyBusiness: "Google Maps locations quality",
      websites: "Website quality",
      socialMedia: "Social media profiles quality",
      otherMaps: "Other maps visibility"
    },

    title: "Welcome back!",
    daysRange: "Last {0} days",
    widgetTitle: {
      averageRating: "Average rating",
      ratingCount: "Number of reviews",
      repliesPercentage: "% reviews replied",
      ratingDistribution: "Rating distribution",
      bestGmbAddresses: "Best rated locations",
      worstGmbAddresses: "Lowest rated locations",
      lowestQualityGmbAddresses: "Locations with lowest quality in Google Maps",
      postsCount: "Posts added",
      viewsCount: "Locations views",
      queriesCount: "Locations searches",
      queries: "Search queries types",
      actionsDrivingDirections: '"Request directions" actions',
      actionsWebsite: '"Visit website" actions',
      actionsPhone: '"Phone call" actions'
    },
    widgetTooltip: {
      comparedToLast30Days: "In comparison to previous 30 days",
      averageRating: "Average rating",
      ratingCount: "Number of ratings",
      repliesPercentage: "% reviews replied",
      ratingDistribution: "Rating distribution",
      bestGmbAddresses: "Best rated locations",
      worstGmbAddresses: "Lowest rated locations",
      lowestQualityGmbAddresses: "Locations with lowest quality in Google Maps",
      postsCount: "Posts added",
      viewsCount: "Locations views",
      queriesCount: "Locations searches",
      queries: "Queries type",
      actionsDrivingDirections: '"Request directions" actions',
      actionsWebsite: '"Visit website" actions',
      actionsPhone: '"Phone call" actions'
    },
    ratingDistributionSerie: 'Rating "{0}"',
    addressScore: "Quality {0}/100",
    queriesSerie: {
      direct: "Direct searches",
      indirect: "Discovery searches",
      chain: "Brand searches"
    }
  },

  tooltip: {
    indicator: "Click for more details"
  },

  session: {
    accountTypeSelection: {
      employee: "Employee",
      company: "Company",
      ifHaveAnAccount: "or if you have an account",
      signUpAs: "Sign up as",
      companyOwnerText: `I am an administrator or company owner. I want to create an account for my organization.`,
      employeeText: `We already use Center AI in the company. I want to access the application.`
    },
    employeePage: {
      title: "Employee sign up",
      description1: `If your company already uses Center AI you should receive an invitation to your e-mail address.`,
      description2: `If you haven't received an invitation, ask your administrator to send the invitation.`,
      ifHaveAnAccount: "... or if you already have an account"
    },
    dontHaveAccount: "No account yet?",
    haveAccount: "Already have an account in Center AI?",
    loginWithFacebook: "Sign in with Facebook",
    loginWithGoogle: "Sign in with Google",
    signUpWithFacebook: "Sign up with Facebook",
    signUpWithGoogle: "Sign up with Google",

    login: {
      description: "Enter your e-mail and password to sign in to the panel"
    },

    forgot: {
      description: "Please enter your email to receive a password-reset link"
    },

    reset: {
      description: "Confirm password"
    },

    register: {
      privacyPolicy: "Privacy Policy",
      regulations: "Terms of Use",
      bySigningUpYouAgreeTo:
        "By registering, you confirm that you have read and accepted the {privacyPolicy} and {regulations}.",
      consent_3:
        "I want to receive newsletters and marketing emails (you can change this at any time)."
    },

    agreement: {
      newsletterAndMarketing:
        "I would like to subscribe to the newsletter and e-mail marketing (you can revoke your consent any time)."
    }
  },

  notification: {
    userLoggedInSuccess: "User sign-in successful!",
    activationCodeWasAdded: "Activation code has been added.",
    changesSaved: "Changes saved successfully",
    activationCodeWasNotAdded:
      "This activation code cannot be used. It is no longer valid or pertains to a less comprehensive subscription plan.",
    noCompetitionAdded: "No competitors were added or selected for comparison"
  },

  visibility: {
    summary: {
      businessAddressesTitle: "Visibility in Google Maps",
      websitesTitle: "Visibility in Google search results",
      noBusinessAddressesInfo:
        "By adding a business address of a given location you can see the map which shows your company's ranking in Google searches.",
      noKeywordsInfo:
        "For each added keyword, Center AI will monitor the position of your listings in the Google Maps search. To add keywords, you first need to add listings to Center AI.",
      noWebsiteAddress: "No website address",
      noWebsiteAddressInfo:
        "By adding your own website address you can learn your current ranking.",
      dataCollectionPendingForKeyword:
        "Data for this keyword is being prepared.",
      dataCollectionForKeywordTryAgainLater:
        "Center AI radars are now operational! We are currently harvesting data.",
      addKeywords: "Add search keywords.",

      map: {
        info:
          "This map shows the position of your <b>location</b> in Google Maps based on the specific keyword and user’s location. Colors match the strength of your listing in a given area. For example, green color means the strongest (closer to no. 1), whereas red stands for the weakest among the top 20 (closer to no. 20), and gray means outside of the top 20.",
        subtitle: "The position of your location in Google Maps",
        legend: {
          high: "High",
          medium: "Medium",
          low: "Poor",
          info:
            "Your location's position in Google Maps search results based on a chosen keyword:",
          nodata: "No data available"
        }
      },

      chart: {
        title: "Average location position within its vicinity",
        description:
          "The chart below shows your location's average position in a given area."
      },

      websites: {
        label: {
          yourWebsiteAddress: "Your website",
          localization: "Location",
          competitionWebsiteAddress: "Competitor website"
        },

        chart: {
          yAxisLabel: "Position in Google search results"
        },
        subtitle:
          "Your website's position in Google search engines in response to a given keyword"
      }
    },

    GMBSummary: {
      history: {
        select: {
          centerRate: "Center AI rating",
          googleMapsRate: "Google Maps rating",
          googleMapsRatingQty: "Number of Google Maps ratings",
          profileCompletness: "Profile Completeness"
        }
      },
      rate:
        "Center AI rating (0-100) - Overall rating for your location's Google Maps profile. The rating is based on the completeness of your profile, customer ratings and customer activity (new ratings and reviews).",
      avgRateInfo:
        "The most relevant reviews are reviews which are highlighted by Google and shown on your Google Maps listing’s main page. These are the reviews your customers see first."
    },

    mapsVisibility: {
      title: "Your locations on other maps",
      tooltip: {
        bing:
          "Microsoft Bing Maps. One of the most popular map services online.",
        openStreetMap:
          "These maps are a community project, may be used free of charge and locations may be edited freely. This makes them extremely popular and widely used for commercial purposes. For example, Yanosik and JakDojadę are amongst its users in Poland.",
        targeo:
          "These Polish maps are one of the most accurate maps on the market. Automapa, a popular GPS service, makes use of those maps.",
        yanosik:
          "This is a community road alert service manged by and for drivers. It helps over 1.5 million drivers every month in Poland.",
        jakDojade:
          "This is Poland's favourite public transport journey planner used by 3.5 million passengers every month. It operates in over 45 Polish cities. In particular, students and young adults seem to favour it.",
        automapa:
          "It is one of Poland's most popular GPS services. Used and appraised by many drivers."
      }
    }
  },

  competition: {
    header: "Competitors websites",
    businessAddresses: {
      title: "Your competitor's listings",
      noSuggested: "No suggested competitors locations",
      suggestedTooltip:
        "Locations which have been listed in search results for your keywords",
      label: {
        yourBusinessAddress: "Location address",
        addCompetitionBusinessAddress: "Add competitor's location"
      },
      noData:
        "To add a competitor business type their company name or city or choose from the suggested competitor listings below."
    },
    visibility: {
      businessAddresses: {
        chartTitle:
          "Average location position and competitors position in immediate vicinity",
        chartDescription:
          "The chart below shows your location's average position compared with selected  competitors.",
        cardTitle: "Find out who is at the top of search results in your area.",
        cardDescription:
          "Choose your location and tick up to 5 locations of your competitors.",
        cardInfo:
          "The colors on the map represent the locations of businesses and indicate which location ranks the highest in Google Maps search results (among the selected locations) for the chosen keyword, depending on where the customer is. For example, orange shows where someone searching for a specific product or service sees your location ranked highest.",
        inputLegend: "Your business location on the map",
        listTitle: "Competitors locations",
        listNoData: "No competitors locations listed",
        searchingData:
          "We are currently processing your query on the selected keyword.",
        addNewTerm: "Add keywords. Most popular keywords will appear here."
      },
      title: "Competitors visibility in Google and Google Maps",
      keywordsTitle: "Monitored keywords",
      nodata: {
        title: "No website address listed",
        content:
          "By adding your own website address you can learn your competitors' current position."
      }
    }
  },

  analytics: {
    wellDone: "Well done",
    needFix: "Need improvements",
    scale: {
      great: "Great",
      good: "Good",
      medium: "Average",
      weak: "Weak"
    },

    businessAddresses: {
      dataCollectInfoText:
        "Starting January 2024, the number of direction requests might be lower than before. This is due to Google changing the way these data are counted.",
      here: "here",
      archiveAlert1: "To see the previous version of this page click",
      archiveAlert2:
        'The previous version shows information about the number of searches for your locations. However, because of Google changes, all data available in the previous version will be updated only until <span class="text-primary">February 28, 2023</span>',
      postStatAlert2:
        'Posts analytics will be available only until <span class="text-primary">February 28, 2023</span> (because of changes introduced by Google).',
      noData:
        "Here you can see how often users viewed your locations in Google Maps and Google Search and what actions they took. This feature will help you gain valuable insight into users' behavior.",
      title: "Users actions in Google Maps",
      titleTooltip:
        "Here you can see how often users viewed your locations in Google Maps and Google Search and what actions they took. This feature will help you gain valuable insight into users' behavior.",
      subtitle: {
        search: "Profile searches",
        actions: "Customer actions after viewing your locations",
        displays: "Locations views"
      },
      noCompare: "Don't compare",
      compareWithPreviousPeriod: "Previous period",
      compareWithPreviousYear: "Previous year",
      showConversionRate: "Show conversion rate",
      chart: {
        directDiscoveryBranded: {
          title: {
            text: "Search type",
            tooltip:
              "Multiple ways lead your customers to your business profile. For example, they might look for your brand directly or type a more general category in their search bar."
          },
          label: {
            text: {
              direct: "Direct searches",
              indirect: "Discovery searches",
              branded: "Brand searches"
            },
            tooltip: {
              direct:
                "Customers that found your listings by your brand's name.",
              indirect:
                "Customers who found your listings searching for a category, product or service.",
              branded:
                "Customers that found your listings searching for brands associated with your business."
            }
          }
        },
        searches: {
          title: {
            text: "Total searches",
            tooltip:
              "Total number of all types of searches within a selected period."
          }
        },
        searchMaps: {
          title: {
            text: "Google Search vs Google Maps",
            tooltip:
              "Your location is visible in Google search and Google Maps. Here you can find out where you are viewed most often."
          },
          label: {
            search: "Views in Google search",
            maps: "Views in Google Maps"
          }
        },
        maps: {
          title: {
            text: "Views",
            tooltip:
              "Total number of views of selected locations in Google Search and Google Maps."
          }
        },
        clicks: {
          title: {
            text: "Website visits",
            tooltip:
              "A total number of your website visits redirected from your Google Maps locations."
          }
        },
        directions: {
          title: {
            text: "Travel directions requests",
            tooltip:
              "A total number of direction requests to your Google Maps locations."
          }
        },
        calls: {
          title: {
            text: "Phone calls made to your business",
            tooltip:
              "A total number of phone calls made through your Google Maps locations."
          }
        },
        clicksConversion: {
          title: {
            text: "Website visits",
            tooltip:
              "A total number of your website visits redirected from your Google Maps locations."
          }
        },
        directionsConversion: {
          title: {
            text: "Travel directions requests",
            tooltip:
              "A total number of direction requests to your Google Maps locations."
          }
        },
        callsConversion: {
          title: {
            text: "Phone calls made to your business",
            tooltip:
              "A total number of phone calls made through your Google Maps locations."
          }
        },
        common: {
          totalViews: "Views",
          conversion: "Conversion rate"
        }
      }
    },
    websites: {
      noWebsitesAdded: "No websites provided.",
      addWebsite: "Add website",
      noAuditYetTryAgainLater:
        "Audit for this website in not ready yet. Please try again later."
    },
    periodic: {
      title: "Position in Google Maps search results",
      tooltip: {
        [PERIODIC_REPORT_TYPE.TOP]:
          "Here you can see how often your locations are visible at positions 1-3, 4-10, and 11-20 in search results for the selected keywords.",
        [PERIODIC_REPORT_TYPE.AVERAGE]:
          "Here you can see the average position of your location in search results for the selected keywords in a specific timeframe."
      },
      allSelected: "(all)",
      keywords: {
        label: "Keywords",
        noKeywords: "No keywords have been chosen",
        dialog: {
          [PERIODIC_REPORT_TYPE.TOP]: {
            title: "Choose keywords"
          },
          [PERIODIC_REPORT_TYPE.AVERAGE]: {
            title: "Choose keyword",
            infoBox:
              "You can choose only one keyword for <b>Average position</b> chart"
          },
          filterInputPlaceholder: "Which keyword are you looking for?"
        }
      },
      types: {
        [PERIODIC_REPORT_TYPE.TOP]: "Top positions",
        [PERIODIC_REPORT_TYPE.AVERAGE]: "Average position"
      },
      chart: {
        tabTitle: "Chart",
        yAxisLabel: {
          [PERIODIC_REPORT_TYPE.TOP]: "Number of locations",
          [PERIODIC_REPORT_TYPE.AVERAGE]:
            "Average position in Google Maps search results"
        },
        noKeywordsDescription:
          "Choose keywords and we will show you\nappropriate charts"
      },
      table: {
        tabTitle: "Table",
        noKeywordsDescription:
          "Choose keywords and we will show you data in table",
        groupFacilities: "Group locations",
        gmbAddress: "Location",
        group: "Group",
        summary: "Summary",
        summarySecondaryText: "of all chosen locations"
      }
    },
    comparator: {
      title: "Compare Google Maps listings",
      showDifference: "Show differences",
      addDescription:
        "Here you can compare two sets of Google Maps listings. To see a comparison select listings to compare (in sets A and B).",
      groupA: "Google Maps listings (set A)",
      groupB: "Google Maps listings (set B)",
      addFacilities: "Select listings",
      reviewsOverall: "Reviews - all",
      reviewsLastMonth: "Reviews - last 30 days",
      averageRating: "Average review rating",
      mostAccurateAverageRating: "Average rating for the most relevant reviews",
      reviewsCount: "Ratings in total",
      reviewsRatings: "Ratings distribution",
      reviewsAswersPercentage: "% reviews replied",
      postsOverall: "Posts - all",
      postsLastMonth: "Posts - last 30 days",
      posts: "Posts in total",
      postsDistribution: "Posts types distribution",
      postType: {
        [POST_TYPE.STANDARD]: "Standard",
        [POST_TYPE.EVENT]: "Event",
        [POST_TYPE.OFFER]: "Offer",
        [POST_TYPE.ALERT]: "Alert"
      }
    }
  },

  companyProfile: {
    tab: {
      termsInBrowsers: "Monitored keywords"
    },
    settings: {
      subscriptionInfo:
        "To change subscription plan please enter activation code",
      subscriptionType:
        'You are using "{variable}" subscription plan, valid through {variable2}',
      subscriptionName: "Plan: {name}",
      subscriptionExpiration: "Next renewal date: {date}",
      subscriptionExpired: "Your subscription plan has expired",
      manageSubscription: "Manage Plan",
      pay: "Settle Invoices",
      expired:
        "Your subscription plan has expired. To renew your subscription please contact us on chat or via e-mail at support@center.ai."
    },
    noData: {
      title:
        "You have no Business Profiles (Google Business Profile Manager) associated with Center AI.",
      description:
        "Add a Business Profile to fully benefit from the functionalities offered by Center AI. By integrating your Google account with Center AI, you will be able to bulk edit your listings, bulk publish your posts and monitor the position of your listings in Google Maps search results with reference to search phrases used."
    },
    listings: {
      title: "Google accounts",
      subtitle: {
        mainSection: "Connected accounts",
        asideSection: "Apply changes to"
      },
      aside: {
        title: "Apply changes to",
        description:
          "Please select maps which you would like to update regarding your business locations. We will update only those locations where you are listed as owner, that is those which you have imported from your Google account."
      },
      description: {
        mainSection:
          "To make use of all Center AI features, make sure you connect your Google account to our toolkit and import you locations. All the accounts that you have already integrated with Center AI will appear here.",
        asideSection:
          "Please select maps which you would like to update regarding your business locations. We will update only those locations where you are listed as owner, that is those which you have imported from your Google account."
      },
      refreshInfo:
        "Can't see your location on the list? Data is refreshed every 10 minutes. Please try again in a moment.",
      importSummary: {
        locationsImport: "Locations import",
        lastImport: "Last import:",
        importedLocations: "Imported locations:",
        importedStatistics: "Imported {current_count} of {total_count}",
        importInProgress: "Data import in progress.",
        lastCheckedAt: "Last time checked at {time}",
        dialogMessages: {
          importing: "Locations selected for import: {importing_count}",
          successfullyImported: "Imported locations: {success_count}",
          error:
            "Some of selected locations ({error_count}) could not be imported because some of information for these locations was missing.",
          alreadyImported:
            "Some of locations ({already_imported_count}) have already been imported to Center AI from another Google account and there was no need to import them again.",
          unverified: "Ignored unverified locations:"
        }
      },
      actionsDisabledDuringImport:
        "During data import, this screen will remain inactive. Other functionalities will work unhindered, though.",
      deleteBusinessAddressesListDialog: {
        title: "Select locations you would like to remove from Center AI"
      },
      businessAddressesListDialog: {
        noData: "There are no locations associated with this account",
        title: "Select locations you would like to import",
        statuses: {
          is_disabled: "Disabled",
          is_disconnected: "Disconnected",
          is_duplicate: "Duplicate",
          is_pending_review: "Review in progress",
          is_permanently_closed: "Closed",
          is_published: "Published",
          is_suspended: "Suspended",
          is_verified: "Verified",
          needs_reverification: "Reverification needed"
        }
      },
      confirmationDialog: {
        textImport:
          "Locations were successfully imported and should appear on you locations list.",
        textImportPending: "Importing listings now.",
        textImportPendingDescription:
          "Meanwhile, we suggest you focus on <a href='https://center.ai/blog/' target='_blank'>our blog</a>. Articles in our blog will help you better grasp the business value that Center AI brings, as well as suggest some best practices.",
        importedStatistics: "Imported {current_count} of {total_count}",
        textDelete: "Selected location have been removed from Center AI.",
        textProfileDelete:
          "Selected profile and all associated locations have been removed from Center AI.",
        textAccountDelete:
          "Your account and all associated profiles have been removed from Center AI.",
        importErrorTitle: "An error occurred while adding new account",
        deleteErrorTitle:
          "An error occurred while removing account from Center AI",
        deleteProfileErrorTitle:
          "An error occurred while removing profile from Center AI",
        deleteAccountErrorTitle:
          "An error occurred while removing Google account from Center AI",
        deleteAccountConfirm:
          "Are you sure you would like to remove the Google account from Center AI?",
        deleteProfileConfirm:
          "Are you sure you would like to remove the profile from Center AI?",
        deleteFacilityConfirm:
          "Are you sure you would like to remove the location from Center AI?",
        importErrorText:
          "Oops, something went awry... Your locations could not be imported. Please, try again.",
        deleteErrorText:
          "Oops, something went awry... Selected locations could not be removed. Please, try again.",
        deleteProfileErrorText:
          "Oops, something went awry... profile could not be removed. Please, try again.",
        deleteAccountErrorText:
          "Oops, something went awry... Google account could not be removed. Please, try again.",
        tooManyRequestsErrorText:
          "Your subscription plan does not allow as many locations. To increase the locations quota please e-mail us at support@center.ai or use the chat in the bottom right corner of the screen.",
        preAddAccount: {
          title: "Permissions for Center AI",
          description:
            "Center AI requires access permissions to your business locations in Google Maps. This is required to help you in locations management.",
          descriptionSecondary:
            "In order to give these permissions, check a box when asked for permissions as shown below:",
          imgAlt: "How to check the right box."
        },
        postAddAccount: {
          error: {
            title: "Permissions for Center AI",
            description:
              "Adding Google account failed because you haven't granted the required permissions.",
            descriptionSecondary:
              "Center AI requires permissions to your business locations in Google Maps. This is required to help you in locations management."
          }
        }
      },
      noProfilesAdded: "No profiles added yet."
    },
    monitoredKeywords: {
      title: "Monitored keywords",
      subtitle: "What do your customers search for?",
      subtitleTooltip:
        "Type keywords for which you want to monitor your position.",

      keywordsScope: "Keywords scope",
      scope: {
        [KEYWORDS_SCOPE.COMPANY]: "All locations",
        [KEYWORDS_SCOPE.GROUP]: "Group",
        [KEYWORDS_SCOPE.FACILITY]: "Chosen location"
      },
      keywordsSection: {
        title: "Monitored keywords",
        keywordInputPlaceholder: "Add keyword",
        infoBoxContent:
          "To add a keyword type it above and press Enter on your keyboard or click the Add button.",
        noKeywords: "You are not monitoring any keywords at the moment",
        noKeywordsAlt: "No keywords"
      },
      deleteDialogLabel: "Would you like to delete selected keyword?",
      chosenKeywordDeleted: "Chosen keyword has been deleted"
    }
  },

  facilityDetails: {
    title: "Location details",
    backToFacilitiesList: "Back to locations list",
    showIn: "Show in",
    mapButton: "Google Maps",
    bingMapButton: "Bing Maps",
    startDate: "Opening date",
    openingHours: "Opening hours",
    openingHoursInfoText:
      "The following opening hours will be set for the entire week. For instance, if you set your opening hours to 9 am till 5 pm for Mondays only, whereas all the remaining days will be set as closed, then as a result of changes all opening hours both on Mondays and the remaining days will be modified (as stated in the form above).",
    customOpeningHours: "Special opening hours",
    customOpeningHoursInfoText:
      "Opening hours will be set only for the days selected above. No other day will be modified.",
    allDayOpeningHours: "Open 24h",
    statusOnMaps: "Status on the maps",
    typeOfMap: "Map",
    status: "Status",
    details: "Details",
    lastUpdateDate: "Last update",
    reviewFormLink: "Link to the review submission form in Google Maps",
    technicalDetailsDialog: {
      title: "Technical details",
      locationName: "gmb_location_name"
    },
    statuses: {
      pending: "Awaiting update",
      inProgress: "Update in progress",
      ok: "Up to date",
      failed: "Update failed",
      externalChange: "External changes to business information",
      noData: "No data on status",
      lastUpdateNoData: "Last update date unknown"
    },
    statusDescription:
      "You can see the status of your updates below. Center AI  updates your Google Maps locations within a few minutes. However, it may take longer due to Google data verification.",
    forms: {
      streetAndHomeNumber: "House/flat No.",
      websiteAddress: "Website address",
      phoneOne: "Phone number 1",
      phoneTwo: "Phone number 2"
    },
    addWorkingHours: "Add opening hours",
    addAnotherDay: "Add another day",
    validation: {
      date: "Year and month are required"
    },
    footer: {
      openingHours:
        "Once saved, changes will undergo verification, which may take up to 3 days. Normally it takes a few minutes."
    },
    noChangesInForm:
      "No changes in the form. Please select the field you would like to update",
    facilityDescription: "Business location description",
    urlAttributes: {
      title: "URL attributes",
      facilityAttributes: "Location URL attributes",
      facilitiesAttributes: "Location URL attributes",
      noAttributesSelected: "No URL attributes were selected",
      editMessage:
        "Add or delete URL attributes (links), e.g. link to your restaurant’s menu, to communicate more information about your locations.",
      addAttributes: "Add URL attributes",
      addAttributesInfo:
        "Add URL attributes to communicate more information about your locations and enable easier connection with valuable external sources.",
      addingAttributes: "Adding URL attributes",
      addAttributesQuestion: "Would you like to add additional URL attributes?",
      addAttributesDescription:
        "Provide URL attributes to add to selected locations. New URL attributes will be added alongside the already existing URL attributes without changing them.",
      deleteAttributes: "Delete URL attributes",
      deletingAttributes: "Deleting URL attributes",
      deleteAttributesQuestion:
        "Would you like to delete selected URL attributes?",
      deleteAttributesDescription:
        "Choose URL attributes which you would like to delete across the selected locations. Only selected URL attributes will be deleted. Other URL attributes will remain unchanged.",
      changeType: "Do you have something else in mind? Select:",
      changeTypeConfirm:
        'If you decide to change attribute edition mode, all data under "Location URL attributes" in your form will be cleared. The data will be cleared only in the form, individual location\'s URL attributes will not change. Would you like to continue?',
      dialog: {
        title: "URL attributes",
        description: "Below you can add, edit and remove URL attributes.",
        noAttributes: "No URL attributes",
        noAttributesAvailable:
          "This location cannot have additional URL attributes. Additional URL attributes are allowed only for certain business categories (e.g. restaurants).",
        noAttributesToDeleteMassEdit: "No URL attributes to delete.",
        noAttributesAvailableMassEdit:
          "URL attributes addition is impossible, as chosen locations don't have common URL attributes.",
        notEditable:
          "URLs in this section cannot be updated (Google doesn't allow to do that).",
        validationError:
          "Some of URLs in a form are incorrect. Please correct them and save again.",
        addAttributeBtn: "Add URL attribute",
        applyBtn: "Save"
      }
    },
    services: {
      validation: {
        descriptionLength: "Service description cannot exceed {0} characters",
        serviceExists: "Service already exists",
        required: "This field is required"
      },
      addServiceInfo:
        "Custom services will be added to the main business category of selected locations.",
      addDescription: "Add description",
      customServices: "Custom services",
      standard: "Standard",
      custom: "Custom",
      title: "Services",
      addNext: "Add next service",
      selectServiceCategory: "Select service category",
      noServicesSelected: "You have no selected services",
      addServicesInfo: "Add the services you offer in your business.",
      addAnotherCustomService: "Add another custom service",
      addCustomService: "Add custom service",
      customService: "Custom service",
      missingServiceQuestion: "Don't see the service you offer?",
      serviceDescription: "Service description",
      servicePrice: "Service price ({0})",
      price: "Price",
      noPrice: "No price",
      priceFrom: "Price from",
      priceTo: "Price to",
      fixedPrice: "Fixed price",
      deleteService: "Delete service",
      deleteServiceDialogText: "Are you sure you want to delete this service?",
      closeServiceDialogText:
        "Are you sure you want to close the window? Unsaved changes will be lost.",
      addServices: "Add services",
      editServices: "Edit services",
      deleteServices: "Delete services",
      findService: "Find services",
      addingServices: "Adding services",
      addServicesQuestion: "Do you want to add additional services?",
      addServicesDescription:
        "Select new services you want to add to the selected listings. Services will be added to the existing ones, preserving the state of other services.",
      deletingServices: "Deleting services",
      deleteServicesQuestion: "Do you want to delete the selected services?",
      deleteServicesDescription:
        "Select the services you want to delete from the selected listings. Only the selected services will be deleted. Other services will remain unchanged.",
      overwriteServices: "Set services",
      overwritingServices: "Setting services",
      overwriteServicesQuestion: "Do you want to set (overwrite) services?",
      overwriteServicesDescription:
        "Select the services you want to set in the selected listings. This operation will remove all current services and replace them with the ones you selected.",
      clickToRestore: "Click to restore",
      duplicateError: "Service {0} already exists",
      changeType: "Do you have something else in mind? Select:",
      changeTypeConfirm:
        'If you decide to change service edition mode, all data under "Services" in your form will be cleared. The data will be cleared only in the form, individual location\'s services will not change. Would you like to continue?'
    },
    attributes: {
      title: "Attributes",
      facilityAttributes: "Location attributes",
      facilitiesAttributes: "Location attributes",
      findAttributes: "Find attributes",
      facilityDescription: "Business location description",
      noAttributesSelected: "No attributes were selected",
      editMessage:
        "Add, delete or set attributes to communicate more information about your locations and highlight their major attributes. Attributes comprise such information as payment methods, accessibility or free Wi-Fi etc.",
      addAttributes: "Add attributes",
      addAttributesInfo:
        "Add attributes to communicate more information about your locations and highlight their major attributes. Attributes comprise such information as payment methods, accessibility or free Wi-Fi etc.",
      addingAttributes: "Adding attributes",
      addAttributesQuestion: "Would you like to add additional attributes?",
      addAttributesDescription:
        "Choose attributes to add to selected locations. New attributes will be added alongside the already existing attributes without changing them.",
      deleteAttributes: "Delete attributes",
      deletingAttributes: "Deleting attributes",
      deleteAttributesQuestion: "Would you like to delete selected attributes?",
      deleteAttributesDescription:
        "Choose attributes which you would like to delete across the selected locations. Only selected attributes will be deleted. Other attributes will remain unchanged.",
      overwriteAttributes: "Set attributes",
      overwritingAttributes: "Setting attributes",
      overwriteAttributesQuestion:
        "Would you like to set or overwrite the existing attributes?",
      overwriteAttributesDescription:
        "Please select attributes you would like to set across selected locations. This will delete all current attributes in selected locations and set new attributes instead.",
      changeType: "Do you have something else in mind? Select:",
      changeTypeConfirm:
        'If you decide to change attribute edition mode, all data under "Location attributes" in your form will be cleared. The data will be cleared only in the form, individual location\'s attributes will not change. Would you like to continue?'
    },
    categories: {
      primary: {
        title: "Choose primary business category",
        queryPlaceholder: "Search for category",
        applyBtnText: "Set"
      },
      additional: {
        title: "Choose additional business category",
        queryPlaceholder: "Search for category",
        applyBtnText: "Add",
        bulkEditApplyBtnText: "Select",
        bulkEditTooltip:
          "Additional business categories selected above will override (delete) additional business categories which are set at the moment for selected locations."
      },
      deleteCategoryDialogTitle: "Would you like to delete selected category?",
      mayNeedVerification:
        "After adding or editing category, Google may ask for location verification once again"
    },
    labels: {
      title: "Labels",
      deleteLabelDialogTitle: "Would you like to delete selected label?",
      facilityLabels: "Location labels",
      facilitiesLabels: "Location labels",
      findLabels: "Find labels",
      facilityDescription: "Business location description",
      noLabels: "No labels",
      noLabelsSelected: "No labels were selected",
      editMessage:
        "Add, delete or set labels. Labels are not publicly visible in Google Maps.",
      addLabels: "Add labels",
      addLabelsInfo:
        "Add labels to communicate more information about your locations and highlight their major labels.",
      addingLabels: "Adding labels",
      addLabelsQuestion: "Would you like to add additional labels?",
      addLabelsDescription:
        "Choose labels to add to selected locations. New labels will be added alongside the already existing labels without changing them.",
      deleteLabels: "Delete labels",
      deletingLabels: "Deleting labels",
      deleteLabelsQuestion: "Would you like to delete selected labels?",
      deleteLabelsDescription:
        "Choose labels which you would like to delete across the selected locations. Only selected labels will be deleted. Other labels will remain unchanged.",
      overwriteLabels: "Set labels",
      overwritingLabels: "Setting labels",
      overwriteLabelsQuestion:
        "Would you like to set or overwrite the existing labels?",
      overwriteLabelsDescription:
        "Please select labels you would like to set across selected locations. This will delete all current labels in selected locations and set new labels instead.",
      changeType: "Do you have something else in mind? Select:",
      changeTypeConfirm:
        'If you decide to change label edition mode, all data under "Location labels" in your form will be cleared. The data will be cleared only in the form, individual location\'s labels will not change. Would you like to continue?',
      dialog: {
        title: "Labels",
        description:
          "Below you can add, edit and remove labels for chosen location.",
        noLabels: "No labels.",
        addLabelBtn: "Add label",
        applyBtn: "Apply"
      }
    },
    moreHours: {
      title: "More hours",
      facilitiesMoreHours: "Location more hours",
      noMoreHoursSelected: "No more hours were selected",
      editMessage: "Set or delete more hours, e.g. related to delivery hours.",
      setMoreHours: "Set more hours",
      setMoreHoursInfo:
        "Set more hours to communicate more information about your locations opening hours of specific services.",
      settingMoreHours: "Setting more hours",
      setMoreHoursQuestion: "Would you like to set more hours?",
      setMoreHoursDescription:
        "Please select more hours you would like to set across selected locations. This will delete all current more hours in selected locations and set new labels instead.",
      deleteMoreHours: "Delete more hours",
      deletingMoreHours: "Deleting more hours",
      deleteMoreHoursQuestion: "Would you like to delete selected more hours?",
      deleteMoreHoursDescription:
        "Choose more hours which you would like to delete across the selected locations. Only selected more hours will be deleted. Other more hours will remain unchanged.",
      changeType: "Do you have something else in mind? Select:",
      changeTypeConfirm:
        'If you decide to change more hours edition mode, all data under "Location more hours" in your form will be cleared. The data will be cleared only in the form, individual location\'s more hours will not change. Would you like to continue?',
      categoriesDialog: {
        description:
          "You can add additional hours for certain services or offers for selected location.",
        descriptionMassEdit:
          "You can add additional hours for certain services or offers for selected locations.",
        chooseCategory: "Choose category:",
        chooseCategoriesToDelete: "Choose categories to delete:",
        noCategories: "No categories available."
      }
    },
    openStatusDialog: {
      title: "Opening and closing location"
    },
    addingFacilityToGoogleMapsInProgressInfoText:
      "You cannot edit this location because it is currently being added to Google Maps."
  },

  facilityCreate: {
    title: "Create location",
    cancelCreating: "Cancel creating",
    baseForm: {
      heading: "Location's data",
      headingSecondary: "Provide location's name and address.",
      required: "This field is required"
    },
    primaryCategoryRequired: "Primary category is required.",
    accountSelect: {
      heading: "Google account",
      headingSecondary:
        "Choose Google account and Profile, to which you want to add new location:",
      noAccounts: "No Google accounts available, cannot create location"
    },
    createDisabled:
      "Creating new listings in Google Maps from Center AI panel is currently turned off in your account.\nIn order to turn it on please contact support (support@center.ai).",
    dialog: {
      facilityCreated: {
        title:
          "Location has been successfully added to Google Business Profile Manager",
        subtitle: "(GMB account: {account}, profile: {profile})",
        importedToCenter: "and has been imported to Center AI.",
        verificationStarted:
          "Location verification process has started and should finish soon.",
        goToFacilitiesList: "Go to locations list",
        createNew: "Create next location"
      },
      facilityImported: {
        description:
          "Location is being imported to Center AI and will be available in locations list in a few minutes.",
        goToBtn: "Go to locations list"
      },
      createDuplicate: {
        title: "Such location already exists in Google Maps",
        description: {
          main:
            "If you add this location then you risk reating a duplicate. Duplicates may confuse your customers and Google might not show duplicated locations in Google Maps.",
          more: ""
        },
        sureToContinue: "Do you want to continue?",
        confirmBtn: "Yes, create this location in Google Maps"
      },
      inCenter: {
        title: "Location is already in your Google account",
        paragraphFirst:
          "Location with provided name and address is already added to your Google account (GMB account: {account}, profile: {profile}) and is imported to Center AI.",
        paragraphSecond:
          "There is no need to add it again. If you want to update its data, go to location edit view.",
        goToEditView: "Edit location data"
      },
      inGoogle: {
        title: "Google Business Profile Manager Location",
        createNewFacility: "Create new location in Google Maps",
        choiceHeader: "Select location to add to your Google account",
        descriptionTop: {
          onlyExistsInAccount:
            "Location with this name and address is already added to your Google account but is not yet imported to Center AI. Because of that you only need to import it to Center AI.",
          mixWithAndWithoutOwner:
            "Location with this name and address akready exists in Google Maps but is not yet added to your Google account. Locations which we have found are presented in a list below.",
          mixAll:
            "Location with this name and address is already added to your Google account but is not yet imported to Center AI. Because of that you only need to import it to Center AI. We have also noticed that location with this name and address akready exists in Google Maps but is not yet added to your Google account."
        },
        [FACILITY_CREATE_ACTION.EXISTS_IN_ACCOUNT]: {
          text: "Location exists in your GMB account.",
          tooltip:
            "Location is already added to your Google account but is not yet imported to Center AI. You only need  Because of that you only need to import it to Center AI. There is no need to create a new location.",
          descriptionBottom:
            "Selected location is already added to your GMB account with name {account} in profile {profile}. It will be imported to Center AI using this GMB account and profile.",
          goTo: "View in Google Business Profile Manager",
          applyBtn: "Import"
        },
        [FACILITY_CREATE_ACTION.WITH_OWNER]: {
          text: "Location exists in Google Maps and has another owner.",
          tooltip:
            "This location has another owner was added and verified in Google Maps earlier by someone else. This person is the current owner of this location in Google Maps. In order to get access to this location you will need permission from this person.",
          goTo: "View in Google Maps",
          applyBtn: "Ask for access to this location",
          tooltipBottom:
            "After pressing this button you will be redirected to a form allowing you to contact with ą current owner of this location. The form will contain a part of this person's e-mail address. If you recognize this e-mail address it is a good idea to contact this person directly and ask for permission. If you don't recognize it then you need to fill in and send this form. After that Google will inform the current owner about your request. The owner will have a few days to accept or reject your request. If it will be rejected then you still can make an apeal in your Google panel (Business Profile Manager). Lack of response from the current owner will be treated by Google as acceptance of your request."
        },
        [FACILITY_CREATE_ACTION.WITHOUT_OWNER]: {
          text: "Location exists in Google Maps and has no owner.",
          tooltip:
            "This location was added to Google Maps earlier but is not yet verified. This means that it can be easily added to your account.",
          goTo: "View in Google Maps",
          applyBtn: "Add to Google account"
        }
      }
    }
  },

  facilitiesEdit: {
    editSuccess: "Edit successful",
    bulkEditMessage:
      "Bulk edit of locations data is being performed. Until it is finished, you cannot perform new bulk edits of locations.",

    title: "Bulk edit locations",
    checkFieldsDescription:
      "Select fields you would like to update and enter your changes. The changes will be implemented across all selected locations."
  },

  facilitiesAddNew: {
    addExistingFacilities: "Add existing locations",
    importFromGoogleMyBusiness:
      "Import locations from Google Business Profile Manager",
    importFromGoogleMyBusinessDescription:
      "Sign in to your Google account and select those location you would like to add. Data will be automatically imported.",
    analysisPositionAtGoogleMaps: "Analyse positions in Google Maps Search",
    comparingWithCommercialFacilities: "Compare to competitors locations",
    updateDataOnGoogleMaps: "Update data in Google Maps",
    updateDataOnOtherMaps: "Update data on other maps",
    accessToStatistics:
      "Access analytics on user searches and user behaviour for location in Google Maps",
    searchOnGoogleMaps: "Search in Google Maps",
    searchOnGoogleMapsDescription:
      "Search for location in Google Maps using its address or name. Any data that is publicly available will be downloaded automatically",
    addFacilitySearchingOnTheMap: "Add location via search in Google Maps",
    addFacilitySearchingOnTheMapDescription:
      "Search for location in Google Maps using its address or enter its name below. Any data that is publicly available will be downloaded automatically.",
    noAccess: "You have not been authorised to add new locations"
  },

  wizard: {
    addNameAndchooseFromList: "Enter name or choose from the list",
    streetAndHomeNumber: "Street Address",
    fillTaxNumber: "Enter your NIP (for companies registered in Poland only)",
    taxNumberFieldDescription:
      "If your company is registered in Poland you can provide your company tax identification number (NIP) below to automatically get information about your company.",

    businessAddresses: {
      method: {
        title: "Add your locations from Google Maps",
        description:
          "Add your Google account to automatically add all your locations from Google Maps",
        addManually: "Add location manually"
      }
    },

    companyInWeb: {
      name: "Your business online",
      header: "How do your customers find you online?",
      termsTitle: "What do your customers search for?",
      termsDescription:
        "Keywords, which users enter into Google Maps search to look for your business or alike companies.",
      localityTitle: "Where are your customers?",
      localityDescription:
        "Which cities and locations do your potential customers reside in?",
      settingsTitle: "What would you like your customers to find?",
      settingsDescription:
        "Choose a location or website from the list to set the parameters.",
      suggestedAll: "Add to all locations and websites",
      suggestedWebsites: "Add to all websites",
      facilitiesAll: "Add search keyword to all locations",
      facilitiesSelected: "Add search keyword only to selected locations",
      removeLabel:
        "Would you like to remove the keyword form all or selected location only?",
      facilitiesRemoveAll: "Remove from all locations",
      facilitiesRemoveSelected: "Remove from selected only",
      businessAddress: "Business location",
      noAddressesSelected:
        "No location was listed. To proceed please add at least one business location.",
      inLocationVicinity: "in location vicinity"
    },

    validation: {
      companyNotFound:
        "the following NIP number returns no company details. Please make sure you have entered the correct NIP number."
    }
  },

  average: {
    veryWeak: "Very poor",
    weak: "Poor",
    medium: "Medium",
    good: "Good",
    veryGood: "Excellent"
  },

  error: {
    badRequest: "Invalid request. Please contact our support team.",
    unauthorized: "Authorisation required. Please, sign in.",
    notFound: "No assets found. Please contact our support team.",
    server: "Server error. Please contact our support team.",
    other: "Error. Please contact our support team.",
    parsing: "An error occurred while parsing data",
    requiredField: "Required",
    noAccounts: "No added accounts"
  },

  businessAddresses: {
    list: {
      facilityIs: "Facility is",
      isDuplicate: "a duplicate",
      isDisconnected: "disconnected",
      editTooltip:
        "Here you can quickly bulk-edit multiple locations by selecting more than one.",
      tabTitle: "Locations list",
      searchPlaceholder: "Name, address, store code",
      delete: "Delete from Center AI",
      addingToGoogleMaps: "Adding to Google Maps",
      totalFacilitiesCount: "All locations: {0}",
      ignoreUnverifiedFacilities: "Ignore unverified locations"
    },
    groups: {
      tabTitle: "Locations groups",
      noGroups: {
        description:
          "Create groups and group your locations to facilitate information management!",
        button: "Add new group"
      },
      labelGroups: {
        addBtn: "Add new group connected to GMB labels",
        labelGroupListItemTooltip: "Connected to GMB labels",
        labelGroupTooltip:
          "This group is managed automatically by Center AI. The system will automatically add or remove locations to this group based on changes in locations' GMB labels. Locations in this group cannot be added or removed manually.",
        addGroupDialog: {
          title: "Select labels",
          description:
            "Select GMB labels which will be used to create this location group. All locations with all of selected labels will be added to this group. This group will be automatically managed by Center AI which means that the system will automatically add or remove locations from this group based on changes in locations labels."
        }
      },
      groupNotSelected: "No group was selected",

      addNewGroup: {
        title: "Add group",
        chosenCompany: "Selected company: {0}",
        newGroupName: "Group name",
        successfullyAdded: 'Group "{0}" was successfully created'
      },

      editGroup: {
        title: "Edit group name",
        chosenCompany: "Selected company: {0}",
        newGroupName: "Group name",
        successfullyUpdated: "Group was successfully edited"
      },

      emptyGroup: "Group locations to facilitate information management",
      createdGroups: "Your groups:",
      groupSuccessfullyDeleted: 'The group "{0}" was successfully removed',

      facilities: {
        facilitiesInGroup: "Locations in this group",
        addFacilitiesButton: "Add locations",
        emptyGroup: "Group locations to facilitate information management",
        filterInputPlaceholder: "Which location are you looking for?",
        noFacilitiesMatchingQuery: "No locations match search query",
        addFacilitiesToGroup: "Add location to group",
        selectedGroup: "Selected group: {0}",
        facilitiesAdded: 'Locations were added to group "{0}"',
        facilityDeleted: 'Location "{0}" was removed from group "{1}"',
        facilitiesDeleted: 'Locations were removed from group "{0}"'
      }
    },
    quality: {
      viewTitle: "Google Maps locations quality",
      actionButtons: {
        information: {
          add: {
            text:
              "Provide all the necessary information about your location to your clients.",
            label: "Add information"
          },
          edit: {
            text:
              "Make sure that information about your location is up to date.",
            label: "Edit information"
          }
        },
        reviews: {
          text: "Take care of your customers by replying to their reviews.",
          label: "Reply to reviews"
        },
        photos: {
          text: "Upload photos to show your best side.",
          label: "Upload photos"
        },
        posts: {
          text: "Add posts to inform your clients about offers and news.",
          label: "Add posts"
        }
      }
    }
  },

  externalChanges: {
    title: "External changes",
    hasExternalChanges: "There are external changes to be accepted or rejected",
    noChanges:
      "Center AI monitors any changes to your listings suggested by users other than you when the Protect Against Changes function is on. Currently, you have no suggestions on changes or all suggestions have been declined/accepted.",
    noChangesHistory: "External changes history is empty.",
    noChangesAlt: "No external changes.",
    automaticChange: "Center AI protection",
    list: {
      title: "External changes list",
      searchPlaceholder: "Name, address, location code",
      overLimitTooltip:
        "Bulk actions can be performed for maximum of {count} locations."
    },
    protect: {
      title: "Protection against external changes",
      description:
        "Here you can decide if you wish to accept or reject Google users' external changes in your locations. When changes are detected, Center AI will automatically perform some of these actions for you. However, to reject some of the changes you will need to confirm it manually.",
      type: {
        external: "External changes",
        gmb: "Google Business Profile Manager changes"
      },
      alwaysAccept: "Accept",
      alwaysReject: "Reject",
      allFields: "All fields",
      infoDialog: {
        title: "Settings have been saved",
        textContentFirst:
          "You listings will be monitored according to configuration to find changes which occurred outside Center AI. You will be notified when changes that you would like to reject are detected. You will need to confirm their rejection. Changes you would like to accept will be handled by Center AI (your action will not be required).",
        showChangesBtn: "View changes detected earlier"
      }
    },
    history: {
      title: "External changes history",
      searchPlaceholder: "Name, address, location code",
      changeHeaderTooltip:
        "Change in location's data that was performed, accepted or rejected.",
      showAllChanges: "Show all changes ({count})"
    },
    date: "Date",
    origin: "Source",
    type: "Change type",
    user: "User",
    field: "Changed field",
    change: "Change",
    allChanges: "All changes: {count}",
    action: "Action",
    actionPerformed: "Action performed",
    changeDetected: "Change detected",
    additionTooltip: "Added new information.",
    removalTooltip: "Removed existing information.",
    changeTooltip: "Changed existing information.",
    selectedFacilities: "Selected locations: {0}",
    groupChangeDialog: {
      [EXTERNAL_CHANGES_STATUS.ACCEPTED]: {
        title: "Accept external changes",
        text: "Select changes to accept in selected locations.",
        button: "Accept",
        [EXTERNAL_CHANGES_SOURCE.GMB]:
          "You are accepting changes only from this origin: Google Business Profile Manager",
        [EXTERNAL_CHANGES_SOURCE.EXTERNAL]:
          "You are accepting changes only from this origin: External"
      },
      [EXTERNAL_CHANGES_STATUS.REJECTED]: {
        title: "Reject external changes",
        text: "Select changes to reject in selected locations.",
        button: "Reject",
        [EXTERNAL_CHANGES_SOURCE.GMB]:
          "You are rejecting changes only from this origin: Google Business Profile Manager",
        [EXTERNAL_CHANGES_SOURCE.EXTERNAL]:
          "You are rejecting changes only from this origin: External"
      }
    },
    informationalFieldTooltip:
      "Location status has changed. This change cannot be rejected.",
    processingInProgressTooltip:
      "Center AI is currently updating information of this listing in Google Maps. During this process other changes in this location are not allowed. Try again in a few minutes.",
    fields: {
      [EXTERNAL_CHANGES_FIELD.NAME]: "Location name",
      [EXTERNAL_CHANGES_FIELD.STREET]: "Street",
      [EXTERNAL_CHANGES_FIELD.POSTAL_CODE]: "Postal code",
      [EXTERNAL_CHANGES_FIELD.CITY]: "City",
      [EXTERNAL_CHANGES_FIELD.COUNTRY]: "Country",
      [EXTERNAL_CHANGES_FIELD.STORE_CODE]: "Store code",
      [EXTERNAL_CHANGES_FIELD.PRIMARY_CATEGORY]: "Primary business category",
      [EXTERNAL_CHANGES_FIELD.ADDITIONAL_CATEGORIES]:
        "Additional business categories",
      [EXTERNAL_CHANGES_FIELD.WEBSITE]: "Website address",
      [EXTERNAL_CHANGES_FIELD.PRIMARY_PHONE]: "Phone 1",
      [EXTERNAL_CHANGES_FIELD.ADDITIONAL_PHONES]: "Phone 2",
      [EXTERNAL_CHANGES_FIELD.REGULAR_HOURS]: "Opening hours",
      [EXTERNAL_CHANGES_FIELD.SPECIAL_HOURS]: "Special opening hours",
      [EXTERNAL_CHANGES_FIELD.ATTRIBUTES]: "Attributes",
      [EXTERNAL_CHANGES_FIELD.DESCRIPTION]: "Description",
      [EXTERNAL_CHANGES_FIELD.OPENING_DATE]: "Opening date",
      [EXTERNAL_CHANGES_FIELD.LOCATION_STATE]:
        "Google Business Profile Manager status",
      [EXTERNAL_CHANGES_FIELD.OPEN_STATUS]: "Open status",
      [EXTERNAL_CHANGES_FIELD.LABELS]: "Labels",
      [EXTERNAL_CHANGES_FIELD.MORE_HOURS]: "More hours",
      [EXTERNAL_CHANGES_FIELD.SERVICES]: "Services"
    },
    fieldsTooltips: {
      [EXTERNAL_CHANGES_FIELD.REGULAR_HOURS]:
        "Opening hours and more hours (e.g. delivery hours)"
    },
    summaryInfoBar:
      "We have detected {changesCount} in you locations to reject according to your configuration.",
    rejectChanges: "Reject changes",
    changesInfoSection: {
      detectedChanges:
        "We have detected {changesCount} changes to reject (in {facilitiesCount}) for the content fields you want to protect.",
      changesRelatedTo: "These changes are about: {fields}.",
      availableHere:
        "The details of all detected changes are available {link}.",
      here: "here",
      confirmReject: "Click below if you want to reject all changes.",
      noChanges:
        "No changes to reject detected for fields you want to protect.",
      rejectingDialog: "Detected changes are being rejected.",
      rejectDetectedChanges: "Reject detected changes",
      rejectConfirmation: "Are you sure you want to reject detected changes?"
    }
  },

  photos: {
    title: "Add photo",
    facilityLabel: "Photo will be added to",
    facilitiesAll: "all locations (verified)",
    facilitiesAllTooltip:
      "Photos can be sent only to locations verified on Google Maps.",
    facilitiesSelected: "selected locations (verified)",
    facilitiesSelectedTooltip:
      "Photos can be sent only to locations verified on Google Maps. Only such locations are presented on the list in opened dialog.",
    addPhotoTitle: "Photo",
    addPhotoTooltip:
      "Minimum recommended resolution: <b>720 x 720</b> px.<br/> File size: between <b>10 KB</b> do <b>10 MB</b>.<br/> <b>Cover</b> photos are required to have 16:9 aspect ratio.",
    addPhoto: "Add photo",
    changePhoto: "Change photo",
    categoriesTooltip:
      'Category in which a photo will be displayed in Google Maps. Some categories (e.g. Food and drink) might be unavailable for certain business types. If you upload photo to a category which is unavailable for you then this photo will be automatically added to category "Other" instead.',
    send: "Send",
    addMore: "Add more photos",
    photoAddedSuccessfully:
      "Photos were sent. They should appear in Google Maps within 10 minutes.",
    photosNotAdded:
      "Not all photos were sent. Please try again with remaining.",
    facilitiesError: "Wymagana przynajmniej jedna wizytówka",
    countLimitError: 'You can send only one photo with category "{0}"',
    edit: {
      applyChanges: "Apply changes",
      infoBox: "Resize and adapt size according to your needs.",
      rotateRight: "Rotate right",
      rotateLeft: "Rotate left",
      reset: "Reset"
    },
    noData: {
      button: "Add account",
      title: "Add photos to locations in Google Maps",
      desc:
        "Here you may add photos to all your business locations in Google Maps. All it takes is that you enter the photo content once and we will automatically send it to selected or all your business locations. This could save you a lot of time and effort. To use this functionality import your locations by adding Google account to Center AI."
    },
    list: {
      title: "Add photos",
      empty: "Add photos to your cards.",
      notFound: "There are no photos in the selected time period.",
      noPhotos: "No photos",
      addNew: "Add new",
      sendDate: "Sent on",
      mapsStatus: "Status of the entry in Google Maps",
      slStatus: "Status of the entry in Store Locator",
      sendStatus: "Status",
      details: "Details",
      visible: "Entry visible",
      sendToFacilities: "Photo sent to {0}",
      successCount: "{0} posted",
      failedCount: "{0} rejected",
      [GMB_MEDIA_TYPE.ADDITIONAL.NAME]: "Additional",
      [GMB_MEDIA_TYPE.COVER.NAME]: "Cover",
      [GMB_MEDIA_TYPE.LOGO.NAME]: "Logo",
      [GMB_MEDIA_TYPE.EXTERIOR.NAME]: "Exterior",
      [GMB_MEDIA_TYPE.INTERIOR.NAME]: "Interior",
      [GMB_MEDIA_TYPE.PRODUCT.NAME]: "Product",
      [GMB_MEDIA_TYPE.FOOD_AND_DRINK.NAME]: "Food and drink",
      [GMB_MEDIA_TYPE.TEAMS.NAME]: "Team",
      delete: {
        title:
          "Are you sure you want to remove the selected photo from all cards?",
        body1:
          "This action will delete photos in Google Business Profile Manager. Sometimes the deleted photos are still visible on Google Maps for some time (they are deleted by Google with a delay). This is due to the way Google algorithms work and does not affect whether the entry is will be removed by Center AI or directly in the Google Business Profile Manager dashboard. Fortunately, this situation is rare. ",
        body2:
          "Deleting a photo will no longer display it in the Store Locator.",
        confirm: "Yes, delete",
        tooltip:
          "In order to delete this photo please contact us via e-mail (support@center.ai) or via chat."
      },
      status: {
        [GMB_MEDIA_STATUS.PENDING]: "Sending",
        [GMB_MEDIA_STATUS.COMPLETED]: "Sent",
        [GMB_MEDIA_STATUS.FINISHED_WITH_PROBLEMS]: "Sent"
      }
    },
    storeLocator: {
      tooltipSwitchOff:
        "The added photo will not be visible in Store Locator. You can also change the visibility of the photo after adding it.",
      tooltipSwitchOn:
        "The added photo will be visible in Store Locator. You can also change the visibility of the photo after adding it."
    }
  },

  posts: {
    fbDialogTitle: "Select the Facebook post you want to copy",
    usedForGoogleMapsPost: "Used to create a Google Maps post",
    copyFacebookPost: "Copy Facebook post",
    selectPage: "Select page",
    selectPost: "Select post",
    multimedia: "Multimedia",
    checkOriginalPost: "Go to original post",
    planning: {
      authorAndDate: "Author and creation date",
      postsFrom: "Posts from",
      showAllPlannedPosts: "Show all planned posts",
      facilitiesSendTooltip:
        "The post will only be sent to locations that were in the selected {0} at the time of planning the post. Locations that appear in these {0} later will not be included. In addition, if you lose permissions to some locations by the time post is sent, the post will not be sent to them.",
      actionsDisabledTooltip:
        "You do not have permission to edit this post. Contact the author / admin.",
      info:
        "The post will only be sent to locations that were in the selected {0} at the time of planning the post.",
      cities: "cities",
      groups: "groups",
      addPostTo: "You will add post to",
      emptyText: "You have no scheduled posts.",
      publication: {
        publicationDateTitle: "Post publication date",
        publicationDateSubtitle:
          "Select a date and time for the post to be published.",
        now: "Now",
        tomorrowMorning: "Tomorrow morning",
        nextWeek: "Next week",
        anotherDate: "Another date"
      }
    },
    scheduledSending: "Scheduled sending",
    sent: "Sent",
    list: {
      [POSTS_FORM_TYPE.POST]: "Post",
      [POSTS_FORM_TYPE.EVENT]: "Event",
      [POSTS_FORM_TYPE.OFFER]: "Offer",
      [POSTS_FORM_TYPE.ALERT]: "COVID-19 update",
      creatingInProgress: "Sending in progress",
      planned: "Planned",
      titleTooltip:
        "Here you can see the list of posts added with Center AI. The posts  uploaded outside of Center AI (in Google  My Business)  will not be visible in this panel.",
      searchFieldPlaceholder: "Search for posts",
      toogleShowDeletedPosts: "Show deleted posts",
      noPostsAlt: "No posts",
      noPostsDescription:
        "You have published no posts on your listings within the selected period. \nAdd a post to all or a few selected listings to encourage your customers to visit your store and to position your listings in Google Maps search results.",
      noPhoto: "no photo",
      clickInButton: 'in button: "{label}"',
      sendingInProgress: "Sending in progress to",
      sendingFinished: "Sent",
      deletingInProgress: "Deleting in progress",
      deleted: "Deleted",
      sentTo: "Post sent to",
      sentDate: "Sent date",
      editDate: "Edit date",
      deleteDate: "Delete date",
      detailsStatusSent: "Sent {sent_count}/{total_count}",
      sentSuccessCount: "{count} posted",
      sentErrorCount: "{count} rejected",
      durationTime: "Duration time",
      confirmPlannedDeleteDialog: {
        text: "Are you sure you would like to remove this planned post?"
      },
      confirmDeleteDialog: {
        text:
          "Are you sure you would like to remove the post from all locations?",
        description:
          "This action will delete selected posts in Google Business Profile Manager. Sometimes deleted posts might still be visible in Google Maps for a short period of time (they will be deleted with a delay). This problem is related to Google algorithms and it can occur even if posts are deleted directly in Google panel (Business Profile Manager). Fortunately, such a situation is not common."
      },
      facilitiesDialog: {
        defaultTitle: "Post sent to locations below",
        [POST_BY_FACILITY_STATUS.OK]: {
          title: "Post sent to locations below"
        },
        [POST_BY_FACILITY_STATUS.FAILED]: {
          title: "Post not sent to locations below"
        },
        fixError: {
          general: "Contact us"
        }
      }
    },
    add: {
      [POSTS_FORM_TYPE.POST]: "Add post",
      [POSTS_FORM_TYPE.EVENT]: "Add event",
      [POSTS_FORM_TYPE.OFFER]: "Add offer",
      [POSTS_FORM_TYPE.ALERT]: "COVID-19 update"
    },
    // Add new post related texts below
    addTime: "Add time",
    alertHeader: "Notify your customers",
    facilityLabel: "Posts will be added to",
    facilitiesAll: "all locations (verified)",
    facilitiesAllUnverified: "all locations",
    facilitiesAllTooltip:
      "Posts can be sent only to locations verified on Google Maps.",
    facilitiesSelected: "selected locations (verified)",
    facilitiesSelectedUnverified: "selected locations",
    facilitiesSelectedTooltip:
      "Posts can be sent only to locations verified on Google Maps. Only such locations are presented on the list in opened dialog.",
    mainPhoto: "Main photo",
    offerName: "Offer name",
    postName: "Post content",
    eventName: "Event name",
    alertName: "Update your status",
    startDate: "Start date",
    endDate: "End date",
    startTime: "Start time",
    endTime: "End time",
    offerDetails: "Offer details",
    offerCode: "Voucher (optional)",
    offerLink: "Link to offer (optional)",
    offerTerms: "Terms (optional)",
    showExtra: "Add more details (optional)",
    publish: "Publish",
    publishFor: "Publish for {0}",
    preview: "Preview",
    schedule: "Event details",
    postUrl: "URL",
    callToAction: {
      label: "Add button (optional)",
      [POSTS_CALL_TO_ACTION_TYPE.BOOK]: "Book",
      [POSTS_CALL_TO_ACTION_TYPE.ORDER]: "Order online",
      [POSTS_CALL_TO_ACTION_TYPE.SHOP]: "Buy",
      [POSTS_CALL_TO_ACTION_TYPE.LEARN_MORE]: "Learn more",
      [POSTS_CALL_TO_ACTION_TYPE.SIGN_UP]: "Sign up",
      [POSTS_CALL_TO_ACTION_TYPE.CALL]: "Phone now"
    },
    alertTitle: "Changes to your business?",
    alertSubtitle:
      "Inform your customers about the recent changes in your business resulting from the COVID-19 restrictions",
    noData: {
      button: "Add account",
      title: "Add post to locations in Google Maps",
      desc:
        "Here you may add posts to all your location profiles in Google Maps. All it takes is that you enter the post content once and we will automatically send it to selected or all your business locations. This could save you a lot of time and effort. To use this functionality import your locations by adding Google account to Center AI."
    },
    addImage: "Add Photo",
    addImageTooltip:
      "Photo should be in PNG or JPG format. Recommended photo's ratio is 4:3. Minimum resolution is 400 x 300 px and size of 10 kB. Maximum recommended resolution is 8000 x 6000 px and size of 10 MB.",
    postSuccess: "Post was sent. It will appear soon in Google Maps.",
    postPlannedSuccess: "Post was sent. It should appear in Google Maps {0}.",
    select: "Select",
    facilitiesError: "Please select at least one location",
    published: "Published",
    selectedFacilities: "{facilitiesCount} selected",
    selectedCities: "{citiesCount} selected ({facilitiesCount})",
    selectedFacilitiesGroups:
      "{facilitiesGroupsCount} selected ({facilitiesCount})",
    changeButton: "Change",
    viewButton: "View",
    facilitiesToAddDialog: {
      title: "Post will be sent to locations below",
      noFacilities: "No locations have been chosen"
    },
    successfullyDeleted: "Post was deleted.",
    postsGuideBtn: "Posts - guide",
    storeLocator: {
      visibilityStatus: "Status of post in Store Locator",
      tooltipSwitchOff:
        "The added Post will not be visible in the Store Locator. The visibility of the entry can also be changed after it has been added.",
      tooltipSwitchOn:
        "The added Post will be visible in the Store Locator. The visibility of the entry can also be changed after it has been added."
    },
    postVisibility: "Post visible",
    visibleGoogleMaps: "For Google Maps",
    visibleStoreLocator: "In Store Locator"
  },

  reviews: {
    cannotEditOptimisticReply:
      "We are processing your reply. Editing will be possible soon.",
    cannotDeleteOptimisticReply:
      "We are processing your reply. Deleting will be possible soon.",
    aiReply: {
      packetCloseToLimitTooltip: "To increase your package, please contact us",
      onlyTextTooltip: "Can be used only for reviews with text",
      outOfLimitTooltip:
        "This month, it is not possible to generate responses using AI, as the available package has been used up. The package will renew at the beginning of the month. To increase your package, please contact us.",
      error: "Error response from AI",
      replyWithAi: "Reply with AI",
      generateAgain: "Generate again",
      repliesLeft: "Replies left",
      generateWithAi: "Generating reply with AI",
      settingsAiReply: "AI response settings",
      instructionsForAi: "Intructions for AI",
      aiSettingsTip1:
        "How it works: Here you can optionally enter additional instructions that AI will use when generating reply suggestions for reviews. Instructions can pertain to any aspect, such as the style of speech, the use of specific words or sentences, etc. Below is an example of such instructions.",
      aiSettingsTip2:
        'Use formal language but address the review author informally. Always add these sentences at the end: "Thank you for shopping at our store! We look forward to your next visit!"'
    },
    findPhrase: "Find phrase",
    periods: {
      weekly: "Weekly",
      monthly: "Monthly"
    },
    chart: {
      averageRateForCategory: "Average rate in category “{0}” for given period",
      reviewsCountForCategory:
        "Reviews count in category “{0}” for given period"
    },
    dialogs: {
      howDoesAutomaticCategorizationWork:
        "How does automatic categorization work?",
      contact: "Contact us",
      autoCategorizeOldReviews:
        "After enabling automatic categorization, categories are assigned only to new reviews (those that will appear in the future). If you want to automatically categorize older reviews as well, please contact us.",
      addPhrasesToCategoryTitle: "Add phrases to category",
      addPhrasesToCategoryContent: `Add phrases to the category (eg "expensive" to the Price category). Thanks to this
      the system will be able to automatically assign this category to the opinion.`,
      alertBeforeActionFirstLine: `You have made the following changes to the category “{0}”:`,
      alertBeforeActionLastLine: `Are you sure you want to save the changes? They will cause changes to existing and future reviews containing the following phrases.`,
      autoCategorizationTitle: `Automatic categorization of reviews and sentiment analysis`,
      autoCategorizationContent: `The Center Al can automatically assign categories (e.g., "customer service") to each related review. This is done through analysis of the review content.
      Additionally, for each detected category, its sentiment is determined, indicating the emotional tone (positive, neutral, negative).
      <br /><br />To use the automatic categorization and sentiment analysis, you only need to:<br /><br />
      • Define the categories that should be detected. The system only assigns reviews to the categories added to Center Al (it does not detect additional categories on its own).<br />
      • Enable automatic categorization of reviews and sentiment analysis for selected categories.<br /><br />
      Both of these actions can be performed on the category management screen.`,
      manageAlerts: {
        add: `You have added {0} phrases.`,
        delete: `You have deleted {0} phrases.`,
        update: `You have updated {0} phrases.`
      },
      alertAfterEditTitle: ``,
      alertAfterEditContent: `You have made changes to the phrases for the category “{0}”, but you have not turned on automatic categorization. </br> <b> Do you want to enable automatic categorization for this category? </b>`
    },
    allPhrases: "All phrases",
    autCategorizationEnabled: "The category was assigned automatically.",
    autoCategorizationLabel:
      "The category has automatic categorization enabled.",
    autoCategorization: "Automatic categorization",
    allCategories: "All categories",
    phraseList: "Phrase list",
    categoryAssignTitle: "What are these opinions about?",
    categoryAssignSubtitle:
      "Select the categories you want to assign to the selected reviews.",
    enterNewCategory: "Enter new category",
    enterNewPhrase: "Enter new phrase",
    reviews: "Reviews",
    reviewsList: "Reviews list",
    reviewsWith: "Reviews:",
    replyPublished: "Reply published",
    replyRejected: "Reply rejected",
    header: "Reviews for locations",
    all: "All",
    tip:
      "Here you can see all reviews from each of your locations. You can choose to respond to single or multiple reviews at once using a response template. To quickly find specific reviews by keyword or even a whole phrase, use our browser below or the filter in the right corner. Make sure you respond to “most relevant reviews” first, since they are at the top of Google Maps search results.",
    answered: "Replied",
    answer: "Reply",
    assignCategories: "Assign categories",
    answerBtn: "Reply now",
    unanswered: "Unreplied",
    onlyComments: "Reviews with content",
    onlyNotes: "Reviews with a note",
    showDeletedReviews: "Show deleted reviews",
    onlyUpdated: "Reviews edited during the selected period",
    onlyCreated: "Reviews created during the selected period",
    addedToGoogle: "Added to Google Maps",
    writtenWithAI: "Written with AI",
    onlyNoComments: "Reviews without content",
    onlyAccurate: "Most relevant reviews",
    opinions: "Reviews",
    actions: "Actions",
    noComment: "User entered rating only.",
    noData:
      "We have found no reviews on your listings for the selected period. Select a different date range or wait for reviews to be harvested.",
    totalReviewsCount: "All reviews: {0}",
    withReplyReviewsCount: "With reply: {0}",
    withoutReplyReviewsCount: "Without reply: {0}",
    percentageOfAllReviews: "{0}% of all reviews",
    yourAnswer: "Your reply",
    publishAnswer: "Publish reply",
    reviewsAIReplyList: "List of reviews with AI replies",
    suggestedAnswerByAI: "Suggested answer by AI",
    noSuggestedAnswerByAI:
      "At the moment, there are no AI-suggested responses to the feedback.",
    cancel: "Cancel",
    edit: "Edit",
    editAndResend: "Edit and resend",
    delete: "Delete",
    filter: "Filter",
    owner: "Owner reply",
    city: "City",
    cities: "Cities",
    facilities: "Locations",
    facilitiesGroups: "Locations groups",
    rating: "Rating",
    save: "Save",
    dateRange: "Dates range",
    more: "More",
    addedLabel: "Added",
    deletedLabel: "Review deleted",
    accurateLabel: "Most relevant review",
    accurateTooltip:
      "The most relevant reviews are reviews which are highlighted by Google and shown on your Google Maps listing’s main page. These are the reviews your customers see first.",
    search: "Search locations",
    searchCity: "Search city",
    searchFacilitiesGroups: "Search locations groups",
    deleteReplyConfirm: "Are you sure you would like to delete the reply?",
    userDataHidden: "User data hidden",
    noFacilities: {
      button: "Add account",
      title: "View and reply to your customer reviews",
      desc:
        "Here you can easily and conveniently browse reviews from your customers in Google Maps and communicate with your customers. To use this functionality import your locations by adding Google account."
    },
    analyst: {
      title: "Ratings analysis",
      subtitleSummary: "Summary",
      subtitleSummaryTooltip:
        "This panel allows you to browse through all your Google Maps ratings earned since your locations were created. Here you can compare the ratings from different periods to form conclusions about how your customers perceive you in specific contexts and the big picture. Allow your regional or store managers to have access to this feature to help them keep track of customer feedback and apply necessary changes.",
      subtitleRatings: "Ratings distribution",
      subtitleRatingsTooltip:
        "Rating overview of selected locations within the specific period of time.",
      subtitleComparison: "Locations data",
      subtitleHistory: "History",
      averageRating: "Average rating",
      averageRatingTooltip:
        "The average rating of selected locations within the specific period of time.",
      totalRatingCount: "Ratings in total",
      noDataDescription:
        "We are currently harvesting data. The information will be available here in about 1 hour.",
      totalRatingCountTooltip:
        "Total number of selected locations ratings within the specific period of time.",
      gmbAddress: "Location",
      averageRatingFromBegin: "Average rating in total",
      ratingCountFromBegin: "Ratings in total",
      newRatingCount: "Ratings in total",
      reviews: "Ratings",
      selectedPeriod: "Selected period ({0})",
      period: "Period",
      comparedPeriod: "Compared period ({0})",
      allReviews: "All ratings",
      noFacilities: {
        title: "Browse analytics data regarding ratings from your customers",
        desc:
          "Here you can easily analyse Google Maps ratings regarding your locations by checking ranking distribution within a selected period and compare it with the previous period. To use this functionality import your locations by adding an account at Google Business Profile Manager."
      },
      includedRatings: "Uwzględnione oceny",
      allRatingsIncluded:
        "All ratings added or edited during the selected period.",
      newRatingsIncluded:
        "Only ratings added during the selected period. Ratings edited in this period are not included.",
      editedRatingIncluded:
        "Only ratings edited during the selected period. Ratings added in this period are not included."
    },
    replyTemplates: {
      title: "Reply templates",
      use: "Use",
      useTemplate: "Use template",
      chooseTemplate: "Select reply template",
      replyError: "Error sending the reply",
      categories: {
        noCategoriesDescription:
          "Add and categorize reply templates to boost your effectiveness in replying to reviews from your customers.",
        [DIALOG_MANAGE_MODE.ADD]: "Add category",
        [DIALOG_MANAGE_MODE.EDIT]: "Edit category",
        categoryNamePlaceholder: "Category name",
        category: "Category name",
        repliesCount: "Templates count",
        createdBy: "Created by",
        viewButton: "See templates",
        save: "Save"
      },
      templates: {
        [DIALOG_MANAGE_MODE.ADD]: "Add template",
        [DIALOG_MANAGE_MODE.EDIT]: "Edit template",
        category: "Category",
        templateTextPlaceholder: "Reply text",
        noTemplates: "No reply templates in this category",
        backToList: "Back",
        save: "Save"
      }
    },
    tags: {
      changesSavedAutomatically: "All changes are saved automatically",
      activeTags: "Active categories",
      inactiveTags: "Inactive categories",
      tags: "Categories",
      manageTagsBasic: "Manage categories",
      manageTags: "Manage review categories",
      typeNewTag: "Enter a new category",
      addedTags: "Added categories",
      noTagsDescription: "You don't have any categories yet.",
      noTagsFilterDialogText:
        "Currently you don't have any categories added. Provide some to be able to filter by them.",
      addDescription:
        "Type them in the field above, click enter or “Add“ to add them to your category list.",
      selectTagsDescription:
        "Click the above categories to add to the selected opinion.",
      selectTags: "Select categories",
      selectTag: "Select category",
      selected: "Selected",
      reviewTags: "What is this review about?",
      noTagsAssigned: "No categories assigned",
      noTagsSelected: "No categories selected",
      noTagsAvailable:
        "To add a category to your review you must first define the available categories.",
      defineTagsHere: "Define categories here",
      noPermissions:
        "You don’t have permissions to define review categories.\nContact account manager or owner.",
      tagDeleteAlert:
        "Are you sure you want to delete the category <b>{0}</b>? It will be also deleted from all reviews."
    },

    bulkReply: {
      heading: "Bulk answer",
      btnLabel: "Bulk reply",
      infoBoxLabel: "We will add the answer below to each of selected reviews",
      infoBoxLabel2:
        "Reviews that already have a response will be ignored (their responses will not be changed).",
      bulkReplyPlaceholder: "You answer",
      saveBtnLabel: "Publish answer",
      replyInProgress: "Reply sending in progress",
      replyInProgressTooltip:
        "Your response is being published in Google Maps. It will not take too long. In order to check if the response is published refresh this page or come back here in a few minutes.",
      selectCustomReply: "Enter manually",
      selectTemplateReply: "Choose reply templates",
      templateInfoBoxLabel:
        "If you choose more than one template, we will assign the answers randomly",
      category: "Category",
      all: "All"
    },
    sort: "Sort",
    ratingDesc: "Rating: highest first",
    ratingAsc: "Rating: lowest first",
    createDateDesc: "Date: newest first",
    createDateAsc: "Date: oldest first",
    selectedPeriod: "Selected period",
    categories: {
      showOnlyAutoAssignedCategories:
        "Show only automatically assigned categories",
      ratingsInCategory: "Ratings in category {0}",
      averageRateTooltip: "Average rating",
      allLocations: "All locations",
      selectLocations: "Select locations",
      locationsGroup: "Location group",
      selectedPeriod: "Selected period",
      comparedPeriod: "Compared period",
      sentiment: "Sentiment",
      generalSentiment: "General sentiment",
      sentimentChange: "Confirm change",
      changeAnyway: "Change",
      makeChange: "Change",
      sentimentChangeAlert: `The category and sentiment were automatically assigned by our AI assistant based on the content of the review. If you believe the assignment is incorrect, you can change it. Would you like to make a change?`,
      sentimentRateInPeriod: `Sentiment rate in category "{0}" in compared period`,

      gridColumns: {
        categories: "Category",
        averageRateInPeriod: "Average rate in period",
        countInComparisonPeriod: "Number of opinions in compared period",
        reviewsCount: "Reviews in total",
        averageRateInComparisonPeriod: "Average rate in compared period",
        averageRateFromBeginning: "Average rate from the beginning",
        reviewsCountInPeriod: "Reviews in total",
        rates: "Ratings",
        actions: "Actions",
        sentiment: {
          sentimentScoreTooltip: `NSS (Net Sentiment Score). NSS allows you to assess the overall sentiment of reviews. It ranges from -100 (when all reviews have a negative sentiment) to 100 (when all reviews have a positive sentiment). NSS is calculated using the formula: 'percentage of reviews with positive sentiment' - 'percentage of reviews with negative sentiment'.`,
          positive: "Sentiment positive",
          negative: "Sentiment negative",
          neutral: "Sentiment neutral",
          unassigned: "Sentiment unassigned",
          sentimentInSelectedPeriod: "Sentiment in selected period",
          sentimentInComparisonPeriod: "Sentiment in comparison period",
          sentimentFromBeginning: "Sentiment from the beginning"
        }
      },
      citySearchPlaceholder: "What city are you looking for?",
      groupSearchPlaceholder: "What group are you looking for?",
      facilitySearchPlaceholder: "What location are you looking for?",
      title: "Reviews categories analysis",
      dataFor: "Data for",
      allFacilities: "All locations",
      selectFacilities: "Select locations",
      selectedRange: "In selected range",
      fromBegin: "From the beginning",
      inGivenPeriod: "In compared period”",
      averageRate: "Average rating",
      reviewsCount: "Number of reviews",
      ratings: "Rating",
      positive: "Positive",
      negative: "Negative",
      chartDescription: `The heat map below illustrates customer reviews by categories. The bigger the rectangle, the more reviews were shared. The color reflects the quality of the reviews, according to the legend below (dark green- the best, to dark red- the worst).`,
      compare: "Compare",
      comparedTo: "compared to",
      categorySearchLabel: "What category are you looking for?",
      averageRateHigherTooltip: `The average rating in the selected period improved relative to
      rate count from the beginning.`,
      sentimentRateHigherTooltip: `The sentiment in the selected period improved relative to
      sentiment from the beginning.`,
      sentimentRateComparisonHigherTooltip: `The sentiment in the selected period improved relative to
      sentiment from the beginning.`,
      countRateHigherTooltip: `The rate count in the selected period improved relative to
      rate count in compared period.`,
      averageRateLowerTooltip: `The average rating in the selected period worsened relative to
      average grade from the beginning.`,
      sentimentRateLowerTooltip: `The sentiment rating in the selected period worsened relative to
      sentiment from the beginning.`,
      sentimentRateComparisonLowerTooltip: `The sentiment rating in the selected period worsened relative to
      sentiment from the beginning.`,
      countRateLowerTooltip: `The rate count in the selected period worsened relative to
      rate count in compared period.`,
      ratesInPeriodTitle: "Reviews in categories",
      facilitiesRatesInPeriodTitle: "Ratings in facilities",

      filters: {
        yesterday: "Yesterday",
        last7Days: "Last 7 days",
        last30Days: "Last 30 days",
        last90Days: "Last 90 days",
        last180Days: "Last 180 days",
        last365Days: "Last 365 days",
        lastWeek: "Previous week",
        lastMonth: "Previous month",
        lastQuarter: "Previous quarter",
        last6Months: "Previous 6 months",
        lastYear: "Previous year",
        fromBeginning: "From the beginning",
        previousTerm: "Previous period",
        previousYear: "Previous year"
      },
      facilityDialog: {
        title: "Select location",
        allFacilitiesTitle: `Show all locations for a company:`,
        allFacilitiesFooter: `The user will always have access to all business cards, also to those that will be added to the company in the future.`
      }
    }
  },

  permissions: {
    usersTooltip:
      "You can add new team members here and define their permissions.",
    tooltip:
      "To change location click on the drop down menu above and select a different location.",
    permissions: "Permissions",
    selectedCompany: "Selected company",
    addNewUser: "Add a new user",
    addUserToTeam: "Add user to team",
    addUser: "Add user",
    team: "Team",
    users: "Users",
    youAreOwner: "You are the owner",
    youAreAdmin: "You have full access",
    youAreManager: "You have limited access",
    email: "E-mail",
    emailAddress: "E-mail address",
    teamInvitation: "Invitation status",
    accountType: "Account type",
    accountTypes: {
      [AccountType.OWNER]: "Owner",
      [AccountType.ADMIN]: "Full access",
      [AccountType.MANAGER]: "Limited access"
    },
    managerTooltip:
      "Users with limited access have access only to locations selected by you and can perform only actions selected by you. These actions and locations will be defined in next steps.",
    adminTooltip:
      "Users with full access are granted access to all actions and all locations. Also, they may add and remove locations, import location from Google Business Profile Manager as well as add, remove or restricts other users permissions.",
    invitationStatus: {
      active: "Access granted",
      pending: "Awaiting invite acceptance"
    },
    see: "View permissions",
    all: "All locations",
    resend: "Resend",
    noUsers:
      "Do you need help managing your locations? Authorise your team members to manage locations!",
    invitationSent: "Invitation has been resent",
    accountDeleted: "User was removed from the team",
    permissionsGranted: "Permissions have been granted",
    access: "Access",
    accessTo: "Access to",
    allFacilities: "all locations",
    allPermissions: "unrestricted",
    limitedPermissions: "restricted",
    invitationEmailInfo:
      "* an invitation to join your team was sent to the email address you provided",
    facilitiesInGroupTitle: "Locations in group",
    facilitiesPermissionsTitle: "Select locations to grant access to",
    editFacilitiesPermissionsTitle: "Edit location access",
    previewFacilitiesPermissionsTitle: "Location access",
    facilitySearchPlaceholder: "Which location are you looking for?",
    facilityGroupSearchPlaceholder: "Which group are you looking for?",
    facilitiesList: "Locations list",
    facilitiesGroups: "Locations groups",
    selected: "Selected locations",
    selectedAll: "All locations",
    selectedGroups: "Selected groups",
    userAccessAllTo: "User will have access to all locations in:",
    accessAllFutureInfo:
      "* user will have access to all locations, including those location which may be added to your company later",
    userPermissions: "User permissions",
    editUserPermissions: "Edit user permissions",
    noMembers:
      "Do you need help managing your locations?\n Authorise your team members to manage locations!",
    atLeastOneFacilityRequired: "Please select at least one location",
    editAccountType: "Edit account type",
    backToPermissions: "Back to permissions",
    addCompanyAsOwner: "Add new company"
  },

  permissionsData: {
    group: {
      name: {
        basic: "Basic permissions",
        photos: "Photos",
        gmbEdit: "Editing locations in Google Maps",
        externalChanges: "Managing external changes",
        gmbPosts: "Posting at locations in Google Maps",
        gmbReviews: "Reviews for locations in Google Maps",
        gmbAnalytics: "Analytics for locations in Google Maps",
        storeLocator: "Store Locator",
        questionsAndAnswers: "Questions and Answers",
        reviewBooster: "Review Booster"
      }
    },
    name: {
      viewDashboard: "View dashboard",
      viewFacilitiesData: "View locations",
      viewCompanyData: "View company information",
      manageCompanyData: "Edit company information",
      editFacilityName: "Edit name",
      editFacilityAddress: "Edit address",
      editFacilityStoreCode: "Edit store code",
      editFacilityWebsite: "Edit website",
      editFacilityPhoneNumber: "Edit phone number",
      editFacilityServiceItems: "Edit services",
      editFacilityOpeningDate: "Edit opening date",
      editFacilityDescription: "Edit description",
      editFacilityAttributes: "Edit attributes",
      editFacilityPrimaryCategory: "Edit primary category",
      editFacilityAdditionalCategories: "Edit additional categories",
      editFacilityLabels: "Edit labels",
      editFacilityHours: "Edit opening hours",
      editFacilityOpenStatus: "Edit open / closed state",
      editReviewReplyTemplates: "Edit reply templates",
      viewExternalChanges: "View external changes",
      approveAndRejectExternalChanges: "Approve and reject external changes",
      viewExternalChangesHistory: "View external changes history",
      protectFromExternalChanges: "Manage external changes protection",
      addAndDeletePhotos: "Add and delete photos",
      viewPhotos: "View photos list",
      viewLocalPosts: "View posts list",
      addAndDeleteLocalPosts: "Add and delete posts",
      viewReviewsAnalytics: "View analytics for reviews",
      viewReviews: "View reviews",
      replyReviews: "Reply to reviews",
      viewGmbInsights: "View Google Business Profile Manager analytics",
      viewMapsRankings: "View positions of your locations in Google Maps",
      viewMapsCompetitionRankings:
        "View positions of your competitors locations in Google Maps",
      manageCompetitionPlaces: "Manage competitors locations",
      manageKeywords:
        "Manage keywords which are being monitored in Google Maps searches",
      manageGmbAccount: "Import locations from Google Business Profile Manager",
      manageExternalGmbAddresses:
        "Import locations from outside Google Business Profile Manager",
      viewTeam: "View team members",
      manageTeam: "Manage team",
      manageReviewsCategories: "Manage categories",
      assignReviewsCategories: "Manage reviews categories",
      manageStoreLocator: "Manage Store Locator",
      configureAiReviewReply: "AI review response configuration",
      viewQAndA: "View questions and answers",
      addAndEditQAndA: "Add and edit questions and answers",
      deleteQAndA: "Delete questions and answers",
      viewRbReviews: "View reviews",
      viewRbReviewsAnalytics: "View reviews analytics",
      viewRbForms: "View forms"
    },
    tooltip: {
      viewFacilitiesData: "View location list (without edit permission)",
      viewCompanyData: 'Display company information (on "My Company" page)',
      editFacilityHours:
        "Edit regular opening hours, special hours (for example, opening hours on holidays) and more hours (e.g. delivery hours).",
      editFacilityOpenStatus: "Setting location as opened or closed",
      editFacilityOpeningDate: "Edit location opening date",
      editFacilityAttributes:
        "Edit location attributes. Attributes comprise such information as payment methods, accessibility or free Wi-Fi.",
      manageCompetitionPlaces:
        "Add and remove competitors locations monitored by Center AI",
      manageKeywords:
        "Add and delete keywords which are being monitored in Google Maps searches",
      manageGmbAccount:
        "Managing Google accounts in Center AI (adding and removing accounts) and importing locations from these GMB accounts to Center AI",
      manageExternalGmbAddresses:
        "Importing or removing from Center AI locations which are not associated with Google accounts. These location cannot be edited, but it is possible to monitor them.",
      viewTeam: "View team members",
      manageTeam:
        "Invite new members to join your team, remove team members, grant and restrict each team members' permissions",
      manageCompanyData:
        'Display company information (on "My Company" page) and view and manage Center AI subscription plan (on "Account Settings" page).'
    }
  },

  demoService: {
    language: {
      description: "This account is available only in English."
    },
    modal: {
      text:
        "This is a demo version of Center AI. You are not allowed to modify data. Create a free account to have full access to all the features.",
      buttonText: "OK"
    }
  },
  meta: {
    login: {
      title: "App Center AI - login",
      description:
        "Log in to the Google Business Profile Manager listing management panel"
    },
    signUp: {
      title:
        "Manage services in Google Business Profile Manager and be the first in Google Maps | Center AI",
      description:
        "Analyze data, monitor changes, manage information and optimize the visibility of your business locations in Google Maps from one easy-to-use panel."
    }
  },
  menuLabels: {
    [Module.DASHBOARD]: "Dashboard",
    [Module.POSITION_MONITORING]: "Google Maps rank monitoring",
    [Module.POSITION_SINGLE_LOCATION]: "Ranking - single locations",
    [Module.POSITION_ALL_LOCATIONS]: "Ranking - all locations",
    [Module.POSITION_COMPETITION_COMPARISON]: "Comparison with the competition",
    [Module.USERS_BEHAVIOR]: "Users actions in Google Maps",
    [Module.ANALYTICS_COMPARISON]: "Compare Google Maps listings",
    [Module.LOCATIONS]: "Locations",
    [Module.LOCATIONS_MANAGE]: "Locations management",
    [Module.LOCATIONS_QUALITY]: "Locations quality",
    [Module.EXTERNAL_CHANGES]: "External changes",
    [Module.EXTERNAL_CHANGES_LIST]: "Changes list",
    [Module.EXTERNAL_CHANGES_PROTECT]: "Protection from changes",
    [Module.EXTERNAL_CHANGES_HISTORY]: "Changes history",
    [Module.PHOTOS]: "Photos",
    [Module.POSTS]: "Posts",
    [Module.REVIEWS]: "Reviews",
    [Module.REVIEWS_LIST]: "Reviews list",
    [Module.REVIEWS_ANALYTICS]: "Ratings analysis",
    [Module.REVIEWS_CATEGORIES_ANALYTICS]: "Reviews categories analysis",
    [Module.TEAM]: "Team",
    [Module.SETTINGS]: "Settings",
    [Module.SETTINGS_COMPANY]: "Your company",
    [Module.SETTINGS_KEYWORDS]: "Monitored keywords",
    [Module.SETTINGS_COMPETITION_LOCATIONS]: "Competitors locations",
    [Module.SETTINGS_GMB_ACCOUNTS]: "Google accounts",
    [Module.SETTINGS_FACEBOOK_ACCOUNTS]: "Facebook accounts",
    [Module.SETTINGS_APPLE_ACCOUNTS]: "Apple accounts",
    [Module.SETTINGS_MAP_CONFIG]: "Map configuration",
    [Module.SETTINGS_APPS_CONFIG]: "Apps configuration",
    [Module.STORE_LOCATOR]: "Store Locator",
    [Module.REVIEW_BOOSTER]: "Reviews from Review Booster",
    [Module.REVIEW_BOOSTER_FORM_LIST]: "Forms",
    [Module.REVIEW_BOOSTER]: "Review Booster",
    [Module.REVIEW_BOOSTER_REVIEWS]: "Forms responses",
    [Module.QUESTIONS_AND_ANSWERS]: "Questions and answers"
  },
  weekDaysShort: {
    [WEEK_DAYS.Monday]: "Mo",
    [WEEK_DAYS.Tuesday]: "Tu",
    [WEEK_DAYS.Wednesday]: "We",
    [WEEK_DAYS.Thursday]: "Th",
    [WEEK_DAYS.Friday]: "Fr",
    [WEEK_DAYS.Saturday]: "Sa",
    [WEEK_DAYS.Sunday]: "Su"
  },
  weekDays: {
    [WEEK_DAYS.Monday]: "Monday",
    [WEEK_DAYS.Tuesday]: "Tuesday",
    [WEEK_DAYS.Wednesday]: "Wednesday",
    [WEEK_DAYS.Thursday]: "Thursday",
    [WEEK_DAYS.Friday]: "Friday",
    [WEEK_DAYS.Saturday]: "Saturday",
    [WEEK_DAYS.Sunday]: "Sunday"
  },
  openStatusTypes: {
    [OPEN_STATUS.ANY]: "Any",
    [OPEN_STATUS.OPEN]: "Open",
    [OPEN_STATUS.CLOSED_PERMANENTLY]: "Closed permanently",
    [OPEN_STATUS.CLOSED_TEMPORARILY]: "Temporarily closed"
  },
  facilityStatusTypes: {
    [FACILITY_STATUS.ANY]: "Any",
    [FACILITY_STATUS.IS_VERIFIED]: "Verified",
    [FACILITY_STATUS.IS_UNVERIFIED]: "Unverified",
    [FACILITY_STATUS.IS_DUPLICATE]: "Duplicate",
    [FACILITY_STATUS.HAS_PENDING_VERIFICATION]: "Verification pending",
    [FACILITY_STATUS.IS_INACTIVE]: "No connection"
  },
  bingFacilityStatusTypes: {
    [BING_FACILITY_STATUS.ANY]: "Any",
    [BING_FACILITY_STATUS.NO_CONNECTION]: "No connection",
    [BING_FACILITY_STATUS.CONNECTION_ACTIVE]: "Connection is active",
    [BING_FACILITY_STATUS.PUBLISHING_IN_PROGRESS]: "Publishing in progress",
    [BING_FACILITY_STATUS.PUBLISHING_FAILED]: "Publishing of information failed"
  },
  externalChangesSources: {
    [EXTERNAL_CHANGES_SOURCE.GMB]: "Google Business Profile Manager",
    [EXTERNAL_CHANGES_SOURCE.EXTERNAL]: "External change"
  },
  externalChangesTypes: {
    [EXTERNAL_CHANGES_TYPE.ADDITION]: "Addition",
    [EXTERNAL_CHANGES_TYPE.REMOVAL]: "Removal",
    [EXTERNAL_CHANGES_TYPE.CHANGE]: "Change"
  },
  externalChangesStatuses: {
    [EXTERNAL_CHANGES_STATUS.PENDING]: "Pending",
    [EXTERNAL_CHANGES_STATUS.ACCEPTED]: "Accepted",
    [EXTERNAL_CHANGES_STATUS.REJECTED]: "Rejected",
    [EXTERNAL_CHANGES_STATUS.DELETED_DUE_TO_GMB]: "Deleted via GMB",
    [EXTERNAL_CHANGES_STATUS.DELETED_DUE_TO_CENTER]: "Deleted via Center"
  },
  facilitiesSortingOptions: {
    [FACILITIES_SORTING_OPTION.DEFAULT]: "Default",
    [FACILITIES_SORTING_OPTION.COUNTRY]: "Country A-Z",
    [FACILITIES_SORTING_OPTION.CITY]: "City A-Z",
    [FACILITIES_SORTING_OPTION.STORE_CODE]: "Store code"
  },
  topChartSeries: {
    [TOP_CHART_SERIE.TOP_3]: "Positions 1-3",
    [TOP_CHART_SERIE.TOP_10]: "Positions 4-10",
    [TOP_CHART_SERIE.TOP_20]: "Positions 11-20"
  },
  reviewsTagsSearchTypes: {
    [REVIEWS_TAGS_SEARCH_TYPE.INCLUDE_ALL_TAGS]: "with all chosen categories",
    [REVIEWS_TAGS_SEARCH_TYPE.INCLUDE_ANY_TAG]: "with any of chosen categories",
    noCategories: "without categories"
  },

  gmbVerification: {
    name:
      "When you change name in some cases Google might ask for reverification of your listing. In order to minimize such a possibility remember: your listing name should be the same as your company name. It should not contain city name, marketing phrases or keywords for SEO.",
    category:
      'Google might ask for verification of your location when you add or edit business categories. To avoid such questions, make sure that your business categories describe what your business is, not the type of services it provides (e.g., choose "pizza Delivery" instead of "Takeout Restaurant").',
    dialog: {
      title: "Warning",
      body:
        "You are updating fields ({fields}). When you edit these fields in some cases Google might ask for reverification of your listing.\n\nRead the instructions below to make sure that your updates are in accordance with Gooogle guideline.",
      confirm: "Confirm and continue."
    },
    changes: {
      name: {
        label: "Name",
        description:
          "Listing name should be the same as your company name. It should not contain city name, marketing phrases or keywords for SEO."
      },
      address: {
        label: "Address",
        description:
          "Use precise and complete address to describe your listing's location. Do not include in address information which are not related to a physical location of your listing (e.g. URLs, keywords for SEO)."
      },
      category: {
        label: "Business categories",
        description:
          'Business categories should describe what your listing is, not which services or products it provides. Choose categories that are as specific as possible, but representative of your main business (e.g. choose "Pizza Delivery" instead of "Takeout Restaurant").'
      }
    }
  },
  questionsAndAnswers: {
    expandAnswers: "Expand answers ({0})",
    deleteItemTitle: "Are you sure you want to delete this item?",
    collapseAnswers: "Collapse answers",
    selectLocation: "Select location",
    questionAndAnswer: "Question and Answer",
    title: "Questions and Answers List",
    sharingPubliclyOnGoogle: "You're sharing publicly on Google",
    askQuestion: "Add a question",
    publishAnswer: "Publish answer",
    owner: "Owner",
    tabs: {
      all: "All",
      withoutAnswer: "Unanswered",
      withAnswer: "Answered"
    },
    noDataDescription: "No questions and answers matching selected criteria."
  },
  reviewBooster: {
    additionalQuestions: "Additional questions",
    title: "Review Booster configuration",
    changeBlocked: "Change has been blocked",
    placeholder: {
      contactText: "Damian will tell you more about Review Booster:",

      positiveScreenList: {
        title: "Two review paths - positive",
        firstElement:
          "Customers are asked to rate their shopping experience at a given location.",
        secondElement:
          "Once the rating is posted, customers receive a thank you note and are prompted to leave a review on Google Maps.",
        thirdElement:
          "Finally, customers receive a thank you note for the posted review."
      },
      negativeScreenList: {
        title: "Two review paths - negative",
        firstElement:
          "Customers are asked to rate their shopping experience at a given location.",
        secondElement:
          "If the rating is negative, customers are asked to post a review.",
        thirdElement:
          "Finally, customers receive a thank you note for the posted review."
      },

      list: {
        title: "Two review paths - positive",
        firstElement: {
          title: "Understand your customers better",
          description:
            "Understand your clients clearly. Gathering and analyzing customer reviews, you can better understand your customers' needs. And then, you can use this knowledge to improve and enhance their shopping experience."
        },
        secondElement: {
          title: "Improve your ratings and reviews on Google Maps",
          description:
            "With more than 93% of customers admitting to reading online reviews before making a purchase, improved ratings will surely impact shopping decisions, as well as encourage customers to share their experience with others (only 47% of customers share their positive experiences, as opposed to 97% who decide to share their negative experiences)."
        },
        thirdElement: {
          title: "Drive in-store traffic and boost your profits",
          description:
            "Research shows that 89% of customers are more likely to make another purchase once the store responds to their review. Data confirms that on average reviews can generate an 18% rise in sales!"
        }
      },
      subtitle: "Why Local Review Booster?"
    },
    formList: {
      title: "Forms",
      formLink: "Form links",
      description:
        "Here is a list of all active forms for collecting feedback and reviews. For each, you can download links for individual locations as well as statistics (information on how users used the forms)."
    },
    reviews: {
      title: "Forms responses",
      selectForm: "Select form",
      googleMapsClicked: "Client moved to Google Maps",
      googleMapsClickedAndReviewAdded:
        "Client went to Google Maps and added review",
      aiGenerated: "The user utilized the AI assistant to help write a review.",
      noData:
        "No data available. Please select a different date range or modify the filters."
    }
  },
  storeLocator: {
    general: "General",
    faqTitle: "FAQ",
    faqSubtitle:
      "Preview of FAQ questions and answers for this business listing",
    configSubtitle: "Additional information for Store Locator",
    contactAndSectionsTitle: "Contact and additional sections",
    contactAndSectionsDescription: `Create additional sections in Store Locator such as: list of links,
          bulleted text list, button section, image section.`,
    faqItemTitle: "FAQ",
    backToStoreLocator: "Back to Store Locator",
    faqItemDescription:
      "Create a list of questions and answers to the most frequently asked questions by your customers.",
    faq: {
      noFaq: "No questions and answers available",
      toAllLocations: "For all locations",
      toLocation: "For this location",
      faqCreatorTitle: "FAQ Creator",
      addFaqToFacilities: "Add FAQ to your business listings",
      question: "Question",
      answer: "Answer",
      orderInfoText:
        "Questions in Store Locator will be displayed according to the order below.",
      allFacilities: "All locations",
      editTitle: "Edit",
      changeOrder: "Change order",
      deleteAlertTitle: "Are you sure you want to delete this question?"
    },
    placeholder: {
      title:
        "Optimize your website and increase conversion to store visits with the store locator.",
      subtitle: "Why Store Locator?",
      implementedIn: "See our Client's Store Locator:",
      contactText: "Damian will tell you more about Store Locator",
      phone: "+48 537 340 555",
      consultantName: "Damian Kordyła",
      list: {
        firstElement: {
          title: "Improve your stores' online visibility in Google searches",
          description:
            "Store Locator is optimized for search engines (SEO) which makes your stores easier to find in search results. Individual store's website will be viewed more often, which will boost online traffic as well as in-store traffic."
        },
        secondElement: {
          title: "Increase in-store traffic",
          description:
            "Thanks to our solution every store’s webpage will gain additional content such as images, information on new and special offers, best customer reviews and highest ratings, turning conversion rates into actual in-store visits."
        },
        thirdElement: {
          title: "Save time",
          description:
            "Store Locator allows you to manage information on both your Google Maps Business Profiles and your own website simultaneously, which helps save time."
        },
        fourthElement: {
          title: "Easy to integrate and customise",
          description:
            "The solution can be tailored to your business aesthetics (colour scheme, fonts, logos) to become an integral part of your own website. Additionally, any technical adjustments are amazingly easy and quick, and take but an hour."
        }
      }
    },
    title: "Store Locator configuration",
    saveChanges: "Save changes",
    enableLocator: "Do you want to enable Store Locator?",
    contactUs: "Contact us!",
    basic: {
      title: "General",
      url: "URL",
      urlText: "URL name",
      name: "Name in header",
      addLogo: "Add a logo",
      primaryColor: "Primary color",
      selectPrimaryColor: "Select primary Color",
      favoritesIcon: "Favorites icon"
    },
    facilities: {
      title: "Locations",
      show: "Display",
      allFacilities: "All locations ({0})",
      selectedGroups: "Selected groups",
      searchArea: "Search area"
    },
    floatingButton: {
      text: "Text",
      title: "Additional configuration",
      subtitle: "Additional button visible on every page:"
    },
    reviews: {
      title: "Reviews",
      description:
        "Store Locator reviews are displayed from the newest to the oldest. Additionally, you can limit reviews to only those with specific ratings.",
      selectRatings: "Select the ratings to show",
      onlyWithText: "Reviews only with text"
    },
    posts: {
      title: "Posts",
      description: "Posts displayed in Store Locator can be selected on {0}.",
      descriptionLink: "posts list"
    },
    photos: {
      title: "Photos",
      description: "Photos displayed in Store Locator can be selected on {0}.",
      descriptionLink: "photos list"
    },
    saveSuccess:
      "Changes saved. Changes will appear in Store Locator within 10 minutes.",
    extraInfo: {
      pageTitle: "Store Locator",
      title: "Contact and additional sections",
      offerLink: "Store offer link",
      contact: "Contact",
      sections: "Sections",
      sectionName: "Section name (optional)",
      addNewElement: "Add another",
      removeElement: "Remove last row",
      moveSection: "Move section:",
      selectSectionType: "Select section type",
      noSections: "You don't have any addittional sections yet.",
      linkSection: {
        defaultTitle: "Links section",
        titleAdd: "Add links",
        titleEdit: "Edit links",
        label: "List of links",
        description:
          "Provide a link name that will be displayed to customers on the Store Locator page, and then enter the URL to which we should redirect.",
        columns: {
          text: "URL Name",
          url: "URL Address"
        }
      }
    }
  },
  usersBehavior: {
    lastDaysLabel: "Why can’t I select the last two weeks?",
    lastDaysTooltip:
      "Google makes complete data available with a delay. Because we want to ensure correct conclusions based on complete data, we made selecting the last two weeks impossible."
  },
  offer: {
    showCouponInShop: "Show coupon in shop",
    offerValid: "Offer valid",
    useOnline: "Use online",
    terms: "Terms of use"
  },
  asyncCSVExport: {
    title: "Exporting file",
    content1: "The file is being generated. You can close the window or wait.",
    content2:
      "Once the generation is complete, you will receive an e-mail with the file.",
    download: "Download file",
    generatingInProgress: "File generation in progress",
    fileGeneratingError: "File generation error",
    closeWindow: "Close window"
  },
  notes: {
    note: "Note",
    addNote: "Add note",
    deleteNote: "Delete",
    deleteNoteDescription: "Do you really want to delete this review note?",
    noteAdded: "Note added",
    noteDeleted: "Note deleted",
    noteUpdated: "Note updated"
  },
  sentiment: {
    reviewsProcessing: "Reviews processing",
    reviewsProcessingNumber: "Number of reviews being processed",
    reviewsProcessingNumber2: "Some reviews are being processed",
    reviewsProcessingNumber3:
      "The review is currently being processed to automatically assign categories with sentiments to it. During this process, categories and sentiments cannot be manually edited.",
    inProgressAlert:
      "Processing of <strong>{0} categories</strong> is in progress",
    unknown: "Unknown",
    markAsPositive: "Mark as positive",
    markAsNegative: "Mark as negative",
    markAsNeutral: "Mark as neutral",
    clearSelection: "Clear selection",
    sentimentName: "Sentiment",
    positive: "Positive",
    negative: "Negative",
    neutral: "Neutral",
    unassigned: "Unassigned",
    mixed: "Mixed",
    heatmap: {
      legendTitle: "Sentiment in majority",
      mostly: "Mostly",
      tooltipClickInfo: "Click on the field to see more"
    }
  },
  mapIntegrations: {
    noFacilities: {
      button: "Add account",
      title: "Send location information to multiple destinations",
      desc:
        "Here you can easily enable integration with various maps. This will automatically send information about your locations to them. To make this possible, import your listings by adding a Google account."
    },
    catalog: "Catalog",
    integrationStatus: "Integration status",
    additionalInfo: "Additional information",
    actions: "Actions",
    enable: "Enable",
    disable: "Disable",
    mapConfigurationTitle: "Map configuration",
    infoText: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit.`,
    bing: {
      dialog: {
        enable: {
          title: "Enable integration with Bing Maps?",
          description: `After enabling the integration, selected information about all your current and future locations will be automatically sent to Bing Maps. Your locations that are not present on Bing Maps will be created there (sometimes this may take up to 10 days due to the way Bing Maps operates). Do you want to continue?`
        },
        disable: {
          title: "Disable integration with Bing Maps?",
          description: `From the moment the integration is disabled, no new changes to the locations will be sent to Bing Maps. Do you want to continue?`
        }
      }
    }
  },
  facebook: {
    removePageAndFacilities: "Remove page and facilities",
    noConnectedFacebookAccount:
      "No connected Facebook account, please log in with Facebook to add.",
    addPage: "Add page",
    facebookAccounts: "Facebook accounts",
    loginWithFacebook: "Log in with Facebook",
    info1:
      "To send location information from Center AI to Facebook business cards, you need to add a Facebook account and select the pages that contain the business cards.",
    info2:
      "It is required that the Facebook pages have the appropriate structure - all business cards must be added as Location Pages within the page.",
    accountRemoveAlert: {
      title: "Confirm account disconnection",
      description:
        "After disconnecting, Center AI will lose access to the business cards from this account.<br /> Information from Center AI will stop being sent to these business cards."
    },
    pageRemoveAlert: {
      title: "Confirm disconnection of the page and its business cards",
      description:
        "After disconnecting, Center AI will lose access to the business cards from this page. Information from Center AI will stop being sent to these business cards."
    },
    enableIntegrationAlert: {
      title: "Pages have been added",
      description: `Integration with Facebook for business cards from selected pages has started. To complete this process we will need additional information from you. We will contact you within X days. You can monitor the process status on the <b>"Map Configuration"</b> screen.`
    },
    selectPageDialog: {
      title: "Select pages with business cards",
      description: `Choose the pages with business cards that you want to connect with locations in
      Center AI. After selecting them, we will start the process of matching business cards
      from Facebook to locations in Center AI.
      <br />
      <br />
      Matched business cards will be updated with information from Center AI.`,
      infobox: `This process may require your
      engagement. If necessary, our support department will contact you. You can monitor the process status on the 'Map Configuration' screen.)`,
      confirmAndStartIntegration: "Confirm and start integration"
    },
    noPagesToAdd: "No pages to add",
    goToMapConfiguration: "Go to map configuration",
    goBackToMapConfiguration: "Go back to map configuration",
    completeConfiguration: "Complete configuration",
    configurationInProgress: "Configuration in progress",
    configureAlert: {
      title: "Configure Facebook account",
      description:
        "To enable integration, you must first configure your Facebook account.",
      confirmLabel: "Configure account"
    }
  },
  mobile: {
    common: {
      addApp: "Add application",
      appConfiguration: "Application configuration",
      cancel: "Cancel",
      noApps: "No applications",
      appDeleteAlert: {
        btnText: "Delete",
        title: "Confirm application deletion",
        description: "Are you sure you want to delete the application?"
      }
    },
    googlePlay: {
      listings: {
        subtitle: {
          mainSection: "Added Google Play accounts"
        },
        accountRemoveAlert: {
          title: "Confirm account disconnection",
          description:
            "After disconnecting, Center AI will lose access to the applications realated to this account.<br /> Information from Center AI will stop being sent to these applications."
        },
        appAddForm: {
          appName: "Application name",
          googlePlayUrl: "Google Play URL"
        },
        info:
          "To enable integration, you must first configure your Google Play account."
      },
      name: "Google Play"
    }
  },
  payments: {
    activeSubscriptionDescription:
      "Your subscription is active. Manage your plan or settle any unpaid invoices below.",
    freePlanDescription:
      "Your free trial includes full access to all <b>Standard Plan</b> features. Select a plan to continue after the trial period.",
    selectPlanButton: "Select plan",
    subscriptionExpiryDate: "Subscription expiry date: {date}",
    paymentSummary: "Payment summary",
    vatNumberRetrievalTooltip:
      "Data retrieval is only available for valid Polish NIP numbers",
    paymentMethod: "Payment Options",
    limit: "Limit",
    aboveLimit: "over the limit",
    currently: "Currently",
    overLimit: "Limits exceeded",
    usageLimits: "Exceeded limits",
    viewUsageLimits: "See limits",
    limitDescriptionNoDeletion: `This plan, compared to your current plan, has additional restrictions (limits) that are currently exceeded. To switch to this plan, first remove the excess objects causing the limit overages in the AI Center panel.`,
    limitDescription: `This plan, compared to your current plan, has additional restrictions (limits) that are currently exceeded. To switch to this plan, first remove the excess objects causing the limit overages. Click on the exceeded limit to open a dropdown menu where you can remove excess objects.`,
    limits: {
      max_facilities: "Number of locations",
      max_maps_keywords: "Number of monitored keywords",
      max_ai_categorization_categories: "Number of review categories",
      max_company_users: "Number of users",
      max_listings_competitors: "Number of competitors locations",
      max_websites: "Maximum Websites",
      max_organic_keywords: "Maximum Organic Keywords",
      max_search_locations: "Maximum Search Locations",
      max_website_competitors: "Maximum Website Competitors"
    },
    changePlanHelp:
      "If you want to switch to a different plan, please contact us by sending an email to support@center.ai or by calling 537 340 555.",
    freeTrialPeriod: "free trial",
    daysLeft: "Ends in {0} days",
    freeTrialTooltip: "Go to subscription settings to select a plan",
    freeTrialEndsIn: "Free trial ends on: {0}",
    freeTrialEnded: "Free trial has ended",
    freeTrial: "Free trial",
    title: "Subscription",
    orderDetails: "Selected plan",
    locationsQuantity: "Number of locations",
    payByCard: "Pay by Card",
    payByQuickPayment: "Quick Payments",
    totalPrice: "Total Price",
    perLocation: "{0} net per location monthly",
    monthly: "Monthly",
    annually: "Annually",
    payMonthly: "Monthly payment",
    payAnnually: "Annual payment",
    payNow: "Pay now",
    paymentDetails: "Complete your details and confirm payment",
    selectedPlan: "Plans",
    completeYourPayment: "Complete your payment",
    processingPayment: "Processing payment",
    status: {
      success: "You’re all set!",
      pending: "Your payment is processing.",
      failed: "Payment failed"
    },
    startUsingCenterAi: "Go to app",
    goBackToPayment: "Go back to payment",
    error: "An error occurred while processing the payment.",
    accept: "I accept the",
    paymentsRegulations: "terms of use",
    promoCode: "Promotion code",
    promoCodeText: "Promotion code can be added in the next step",
    invoiceData: "Add Your Billing Information",
    invoiceDataDescription:
      "Make it easy – just enter your VAT ID, and we’ll automatically fill in your company details.",
    getData: "Get data",
    net: "net",
    vat: "VAT",
    pln: "PLN",
    planDialog: {
      title: "Almost there!",
      description: `We've opened the subscription management page in a new tab for you.
              After you complete your changes there, come back here and click the 
              refresh button to see your updated subscription.`
    },
    paymentErrorDescription: `
    We couldn’t process your payment. This might be due to one of the following reasons:

<br />
<br />
    <ul>
<li>Insufficient funds in your account.</li>
<li>Incorrect card details (e.g., number, expiration date, CVV code).</li>
<li>Authorization issues with your bank.</li>
</ul>
<br />

Please try again or contact your bank to resolve the issue.
    `,
    paymentSuccessDescription: `Your payment went through successfully. We’ve sent your invoice to your email. Moving forward, you’ll automatically receive invoices for any payments. You can find the full invoice history in the “User Account” section of your Center AI dashboard.`
  },
  apple: {
    apple: "Apple",
    title: "Apple Accounts",
    loginWithApple: "Login with Apple",
    emptyState: {
      title: "No connected Apple Maps accounts.",
      description:
        "Connect your Apple Maps account to manage business locations in Apple Maps."
    },
    header: {
      title: "Connected accounts"
    },
    info1:
      "To send location information from Center AI to Apple Maps business cards, you need to add an Apple account.",
    configureAlert: {
      title: "Configure Apple Account",
      description:
        "To enable integration, you need to configure your Apple account first.",
      confirmLabel: "Configure Account"
    },
    enableDialog: {
      title: "Enable integration with Apple Maps?",
      subtitle:
        "Apple account has been added successfully. Do you want to enable integration with Apple Maps now?",
      description: `After enabling the integration:
        <ul>
          <li>Existing business cards in Apple Maps will be updated with information from Center AI.</li>
          <li>Business cards in Apple Maps will also be automatically updated whenever you make changes in Center AI.</li>
          <li>
            <b>Updated data: business card name, categories, address, coordinates, phone numbers, standard opening hours, special opening hours, description, store code, website address.</b>
          </li>
          <li>
            If some business cards are missing in Apple Maps, they will be created based on information from Center AI.
          </li>
        </ul><br/>
        You can also enable the integration later. You can also disable it at any time.
      `
    },
    disableDialog: {
      title: "Disable integration with Apple Maps?",
      description: `From the moment the integration is disabled, no new changes to the locations will be sent to Apple Maps. Do you want to continue?`
    },
    accountRemoveAlert: {
      title: "Confirm account disconnection",
      description:
        "After disconnecting, Center AI will lose access to the business cards from this account.<br /> Information from Center AI will stop being sent to these business cards."
    }
  }
};
